window.theme = window.theme || {}, window.Shopify = window.Shopify || {},
    theme.config = {
        bpSmall: !1,
        hasSessionStorage: !0,
        hasLocalStorage: !0,
        mediaQuerySmall: "screen and (max-width: 769px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isTouch: !!("ontouchstart" in window || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints),
        stickyHeader: !1,
        rtl: !("rtl" != document.documentElement.getAttribute("dir"))
    }, theme.config.isTouch && (document.documentElement.className += " supports-touch"), console && console.log && console.log("Impulse theme (" + theme.settings.themeVersion + ") by ARCH\u039ETYPE | Learn more at https://archetypethemes.co"), theme.recentlyViewed = {
        recent: {},
        productInfo: {}
    }, window.lazySizesConfig = window.lazySizesConfig || {}, lazySizesConfig.expFactor = 4,
    function() {
        'use strict';

        function e() {
            var e, t, a = new Promise((a, i) => {
                e = setInterval(function() {
                    Vimeo && (clearInterval(e), clearTimeout(t), a())
                }, 500), t = setTimeout(function() {
                    clearInterval(e), i()
                }, 4e3)
            });
            return a
        }
        theme.delegate = {
                on: function(e, t, a) {
                    return this.namespaces || (this.namespaces = {}), this.namespaces[e] = t, a = a || !1, this.addEventListener(e.split(".")[0], t, a), this
                },
                off: function(e) {
                    if (this.namespaces) return this.removeEventListener(e.split(".")[0], this.namespaces[e]), delete this.namespaces[e], this
                }
            }, window.on = Element.prototype.on = theme.delegate.on, window.off = Element.prototype.off = theme.delegate.off, theme.utils = {
                defaultTo: function(e, t) {
                    return null == e || e !== e ? t : e
                },
                wrap: function(e, t) {
                    e.parentNode.insertBefore(t, e), t.appendChild(e)
                },
                debounce: function(e, t, a) {
                    var i;
                    return function() {
                        var o = this,
                            n = arguments,
                            r = a && !i;
                        clearTimeout(i), i = setTimeout(function() {
                            i = null, a || t.apply(o, n)
                        }, e), r && t.apply(o, n)
                    }
                },
                throttle: function(e, t) {
                    var a = !1;
                    return function() {
                        a || (t.apply(this, arguments), a = !0, setTimeout(function() {
                            a = !1
                        }, e))
                    }
                },
                prepareTransition: function(e, t) {
                    function a() {
                        e.classList.remove("is-transitioning"), e.removeEventListener("transitionend", a)
                    }
                    e.addEventListener("transitionend", a), e.classList.add("is-transitioning"), e.offsetWidth, "function" == typeof t && t()
                },
                compact: function(e) {
                    for (var t, a = -1, i = null == e ? 0 : e.length, o = 0, n = []; ++a < i;) t = e[a], t && (n[o++] = t);
                    return n
                },
                serialize: function(e) {
                    var t = [];
                    return Array.prototype.slice.call(e.elements).forEach(function(e) {
                        return !e.name || e.disabled || -1 < ["file", "reset", "submit", "button"].indexOf(e.type) ? void 0 : "select-multiple" === e.type ? void Array.prototype.slice.call(e.options).forEach(function(a) {
                            a.selected && t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(a.value))
                        }) : void(-1 < ["checkbox", "radio"].indexOf(e.type) && !e.checked || t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value)))
                    }), t.join("&")
                }
            }, theme.a11y = {
                trapFocus: function(e) {
                    function t(e) {
                        9 !== e.keyCode || e.target === r && e.shiftKey && (e.preventDefault(), s.focus())
                    }
                    var a = {
                            focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                            focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                            keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus"
                        },
                        i = e.container.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex^=\"-\"])"),
                        o = [].slice.call(i),
                        n = o.filter(e => null !== e.offsetParent),
                        r = n[0],
                        s = n[n.length - 1];
                    e.elementToFocus || (e.elementToFocus = e.container), e.container.setAttribute("tabindex", "-1"), e.elementToFocus.focus(), document.documentElement.off("focusin"), document.documentElement.on(a.focusout, function() {
                        document.documentElement.off(a.keydown)
                    }), document.documentElement.on(a.focusin, function(e) {
                        e.target !== s && e.target !== r || document.documentElement.on(a.keydown, function(e) {
                            t(e)
                        })
                    })
                },
                removeTrapFocus: function(e) {
                    var t = e.namespace ? "focusin." + e.namespace : "focusin";
                    e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t)
                },
                lockMobileScrolling: function(e, t) {
                    var a = t ? t : document.documentElement;
                    document.documentElement.classList.add("lock-scroll"), a.on("touchmove" + e, function() {
                        return !0
                    })
                },
                unlockMobileScrolling: function(e, t) {
                    document.documentElement.classList.remove("lock-scroll");
                    var a = t ? t : document.documentElement;
                    a.off("touchmove" + e)
                }
            }, document.documentElement.on("keyup.tab", function(e) {
                9 === e.keyCode && (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"))
            }), theme.Currency = function() {
                var e = theme && theme.settings && theme.settings.superScriptPrice;
                return {
                    formatMoney: function(t, a) {
                        function i(e, t, a, i) {
                            if (t = theme.utils.defaultTo(t, 2), a = theme.utils.defaultTo(a, ","), i = theme.utils.defaultTo(i, "."), isNaN(e) || null == e) return 0;
                            e = (e / 100).toFixed(t);
                            var o = e.split("."),
                                n = o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a),
                                r = o[1] ? i + o[1] : "";
                            return n + r
                        }
                        a || (a = theme.settings.moneyFormat), "string" == typeof t && (t = t.replace(".", ""));
                        var o = "",
                            n = /\{\{\s*(\w+)\s*\}\}/,
                            r = a || "$";
                        switch (r.match(n)[1]) {
                            case "amount":
                                o = i(t, 2), e && o && o.includes(".") && (o = o.replace(".", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals":
                                o = i(t, 0);
                                break;
                            case "amount_with_comma_separator":
                                o = i(t, 2, ".", ","), e && o && o.includes(".") && (o = o.replace(",", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                o = i(t, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                o = i(t, 0, " ");
                        }
                        return r.replace(n, o)
                    },
                    getBaseUnit: function(e) {
                        return e ? e.unit_price_measurement && e.unit_price_measurement.reference_value ? 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit : void 0 : void 0
                    }
                }
            }(), theme.Images = function() {
                return {
                    imageSize: function(e) {
                        if (!e) return "620x";
                        var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                        return null === t ? null : t[1]
                    },
                    getSizedImageUrl: function(e, t) {
                        if (!e) return e;
                        if (null == t) return e;
                        if ("master" === t) return this.removeProtocol(e);
                        var a = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                        if (null != a) {
                            var i = e.split(a[0]),
                            o = a[0];
                            return this.removeProtocol(i[0] + "_" + t + o)
                        }
                        return null
                    },
                    removeProtocol: function(e) {
                        return e.replace(/http(s)?:/, "")
                    },
                    lazyloadImagePath: function(e) {
                        var t;
                        return null !== e && (t = e.replace(/(\.[^.]*)$/, "_{width}x$1")), t
                    }
                }
            }(), theme.loadImageSection = function(e) {
                function t() {
                    e.classList.remove("loading", "loading--delayed"), e.classList.add("loaded")
                }

                function a() {
                    return e.querySelector(".lazyloaded")
                }
                if (e.querySelector("svg")) return void t();
                if (a()) return void t();
                var i = setInterval(function() {
                    a() && (clearInterval(i), t())
                }, 25)
            }, theme.initWhenVisible = function(e) {
                var t = e.threshold ? e.threshold : 0,
                    a = new IntersectionObserver((t, a) => {
                        t.forEach(t => {
                            t.isIntersecting && "function" == typeof e.callback && (e.callback(), a.unobserve(t.target))
                        })
                    }, {
                        rootMargin: "0px 0px " + t + "px 0px"
                    });
                a.observe(e.element)
            }, theme.LibraryLoader = function() {
                function e(e, t) {
                    var a = document.createElement("script");
                    return a.src = e.src, a.addEventListener("load", function() {
                        e.status = i.loaded, t()
                    }), a
                }

                function t(e, t) {
                    var a = document.createElement("link");
                    return a.href = e.src, a.rel = "stylesheet", a.type = "text/css", a.addEventListener("load", function() {
                        e.status = i.loaded, t()
                    }), a
                }
                var a = {
                        link: "link",
                        script: "script"
                    },
                    i = {
                        requested: "requested",
                        loaded: "loaded"
                    },
                    o = "https://cdn.shopify.com/shopifycloud/",
                    n = {
                        youtubeSdk: {
                            tagId: "youtube-sdk",
                            src: "https://www.youtube.com/iframe_api",
                            type: a.script
                        },
                        vimeo: {
                            tagId: "vimeo-api",
                            src: "https://player.vimeo.com/api/player.js",
                            type: a.script
                        },
                        shopifyXr: {
                            tagId: "shopify-model-viewer-xr",
                            src: o + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                            type: a.script
                        },
                        modelViewerUi: {
                            tagId: "shopify-model-viewer-ui",
                            src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                            type: a.script
                        },
                        modelViewerUiStyles: {
                            tagId: "shopify-model-viewer-ui-styles",
                            src: o + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                            type: a.link
                        }
                    };
                return {
                    load: function(o, r) {
                        var s = n[o];
                        if (s && s.status !== i.requested) {
                            if (r = r || function() {}, s.status === i.loaded) return void r();
                            s.status = i.requested;
                            var l;
                            switch (s.type) {
                                case a.script:
                                    l = e(s, r);
                                    break;
                                case a.link:
                                    l = t(s, r);
                            }
                            l.id = s.tagId, s.element = l;
                            var d = document.getElementsByTagName(s.type)[0];
                            d.parentNode.insertBefore(l, d)
                        }
                    }
                }
            }(), theme.rteInit = function() {
                function e(e) {
                    e.src = e.src;
                    var t = document.createElement("div");
                    t.classList.add("video-wrapper"), theme.utils.wrap(e, t)
                }
                document.querySelectorAll(".rte table").forEach(e => {
                    var t = document.createElement("div");
                    t.classList.add("table-wrapper"), theme.utils.wrap(e, t)
                }), document.querySelectorAll(".rte iframe[src*=\"youtube.com/embed\"]").forEach(t => {
                    e(t)
                }), document.querySelectorAll(".rte iframe[src*=\"player.vimeo\"]").forEach(t => {
                    e(t)
                }), document.querySelectorAll(".rte a img").forEach(e => {
                    e.parentNode.classList.add("rte__image")
                })
            }, theme.Sections = function() {
                this.constructors = {}, this.instances = [], document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), document.addEventListener("shopify:section:select", this._onSelect.bind(this)), document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
            }, theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
                _createInstance: function(e, t, a) {
                    var i = e.getAttribute("data-section-id"),
                        o = e.getAttribute("data-section-type");
                    if (t = t || this.constructors[o], "undefined" != typeof t) {
                        if (a) {
                            var n = this._findInstance(i);
                            n && this._removeInstance(i)
                        }
                        try {
                            var r = Object.assign(new t(e), {
                                id: i,
                                type: o,
                                container: e
                            });
                            this.instances.push(r)
                        } catch (t) {
                            console.error(t)
                        }
                    }
                },
                _findInstance: function(e) {
                    for (var t = 0; t < this.instances.length; t++)
                        if (this.instances[t].id === e) return this.instances[t]
                },
                _removeInstance: function(e) {
                    for (var t, a = this.instances.length; a--;)
                        if (this.instances[a].id === e) {
                            t = this.instances[a], this.instances.splice(a, 1);
                            break
                        } return t
                },
                _onSectionLoad: function(e, t, a) {
                    window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                    var i = t ? t : e.target,
                        o = t ? t : e.target.querySelector("[data-section-id]");
                    if (o) {
                        this._createInstance(o);
                        var n = t ? a : this._findInstance(e.detail.sectionId),
                            r = i.querySelectorAll("[data-subsection]");
                        r.length && this.loadSubSections(i), n && "function" == typeof n.onLoad && n.onLoad(e), setTimeout(function() {
                            window.dispatchEvent(new Event("scroll"))
                        }, 200)
                    }
                },
                _onSectionUnload: function(e) {
                    this.instances = this.instances.filter(function(t) {
                        var a = t.id === e.detail.sectionId;
                        return a && "function" == typeof t.onUnload && t.onUnload(e), !a
                    })
                },
                loadSubSections: function(e) {
                    if (e) {
                        var t = e.querySelectorAll("[data-section-id]");
                        t.forEach(e => {
                            this._onSectionLoad(null, e, e.dataset.sectionId)
                        })
                    }
                },
                _onSelect: function(e) {
                    var t = this._findInstance(e.detail.sectionId);
                    "undefined" != typeof t && "function" == typeof t.onSelect && t.onSelect(e)
                },
                _onDeselect: function(e) {
                    var t = this._findInstance(e.detail.sectionId);
                    "undefined" != typeof t && "function" == typeof t.onDeselect && t.onDeselect(e)
                },
                _onBlockSelect: function(e) {
                    var t = this._findInstance(e.detail.sectionId);
                    "undefined" != typeof t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e)
                },
                _onBlockDeselect: function(e) {
                    var t = this._findInstance(e.detail.sectionId);
                    "undefined" != typeof t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e)
                },
                register: function(e, t, a) {
                    this.constructors[e] = t;
                    var i = document.querySelectorAll("[data-section-type=\"" + e + "\"]");
                    a && (i = a.querySelectorAll("[data-section-type=\"" + e + "\"]")), i.forEach(function(e) {
                        this._createInstance(e, t, a)
                    }.bind(this))
                },
                reinit: function(e) {
                    for (var t, a = 0; a < this.instances.length; a++) t = this.instances[a], t.type === e && "function" == typeof t.forceReload && t.forceReload()
                }
            }), theme.Variants = function() {
                function e(e) {
                    this.container = e.container, this.variants = e.variants, this.singleOptionSelector = e.singleOptionSelector, this.originalSelectorId = e.originalSelectorId, this.enableHistoryState = e.enableHistoryState, this.currentlySelectedValues = this._getCurrentOptions(), this.currentVariant = this._getVariantFromOptions(), this.container.querySelectorAll(this.singleOptionSelector).forEach(e => {
                        e.addEventListener("change", this._onSelectChange.bind(this))
                    })
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    _getCurrentOptions: function() {
                        var e = [];
                        return this.container.querySelectorAll(this.singleOptionSelector).forEach(t => {
                            var a = t.getAttribute("type");
                            "radio" === a || "checkbox" === a ? t.checked && e.push({
                                value: t.value,
                                index: t.dataset.index
                            }) : e.push({
                                value: t.value,
                                index: t.dataset.index
                            })
                        }), e = theme.utils.compact(e), e
                    },
                    _numberFromOptionKey: function(e) {
                        return parseInt(e.substr(-1))
                    },
                    _getWeightedOptionMatchCount: function(e) {
                        return this._getCurrentOptions().reduce((t, {
                            value: a,
                            index: i
                        }) => {
                            const o = this._numberFromOptionKey(i);
                            return e[i] === a ? t + (4 - o) : t
                        }, 0)
                    },
                    _getFullMatch(e) {
                        const t = this._getCurrentOptions(),
                            a = this.variants;
                        return a.find(a => {
                            const i = t.every(({
                                value: e,
                                index: t
                            }) => a[t] === e);
                            return e ? i && a.available : i
                        })
                    },
                    _getClosestAvailableMatch: function(e) {
                        if (!e) return null;
                        const t = this._getCurrentOptions(),
                            a = this.variants,
                            i = e && a.filter(a => t.filter(({
                                value: t,
                                index: a
                            }) => this._numberFromOptionKey(a) <= this._numberFromOptionKey(e.index)).every(({
                                value: e,
                                index: t
                            }) => a[t] === e) && a.available);
                        return i.reduce((t, a) => {
                            if (null === t) return a;
                            const i = this._getWeightedOptionMatchCount(t, e),
                                o = this._getWeightedOptionMatchCount(a, e);
                            return o > i ? a : t
                        }, null)
                    },
                    _getVariantFromOptions: function(e) {
                        const t = this._getFullMatch(!0),
                            a = this._getClosestAvailableMatch(e),
                            i = this._getFullMatch(!1);
                        return t || a || i || null
                    },
                    _updateInputState: function(e) {
                        return t => {
                            if (null === e) return;
                            const a = t.dataset.index,
                                i = t.value,
                                o = t.getAttribute("type");
                            ("radio" === o || "checkbox" === o) && (t.checked = e[a] === i)
                        }
                    },
                    _onSelectChange: function({
                        srcElement: e
                    }) {
                        const t = this.container.querySelectorAll(this.singleOptionSelector),
                            a = this._getVariantFromOptions({
                                index: e.dataset.index,
                                value: e.value
                            });
                        t.forEach(this._updateInputState(a, e));
                        const i = this.currentlySelectedValues = this._getCurrentOptions(),
                            o = {
                                variant: a,
                                currentlySelectedValues: i,
                                value: e.value,
                                index: e.parentElement.dataset.index
                            };
                        this.container.dispatchEvent(new CustomEvent("variantChange", {
                            detail: o
                        })), document.dispatchEvent(new CustomEvent("variant:change", {
                            detail: o
                        })), a && (this._updateMasterSelect(a), this._updateImages(a), this._updatePrice(a), this._updateUnitPrice(a), this._updateSKU(a), this.currentVariant = a, this.enableHistoryState && this._updateHistoryState(a))
                    },
                    _updateImages: function(e) {
                        var t = e.featured_image || {},
                            a = this.currentVariant && this.currentVariant.featured_image || {};
                        e.featured_image && t.src !== a.src && this.container.dispatchEvent(new CustomEvent("variantImageChange", {
                            detail: {
                                variant: e
                            }
                        }))
                    },
                    _updatePrice: function(e) {
                        this.currentVariant && e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price || this.container.dispatchEvent(new CustomEvent("variantPriceChange", {
                            detail: {
                                variant: e
                            }
                        }))
                    },
                    _updateUnitPrice: function(e) {
                        this.currentVariant && e.unit_price === this.currentVariant.unit_price || this.container.dispatchEvent(new CustomEvent("variantUnitPriceChange", {
                            detail: {
                                variant: e
                            }
                        }))
                    },
                    _updateSKU: function(e) {
                        this.currentVariant && e.sku === this.currentVariant.sku || this.container.dispatchEvent(new CustomEvent("variantSKUChange", {
                            detail: {
                                variant: e
                            }
                        }))
                    },
                    _updateHistoryState: function(e) {
                        if (history.replaceState && e) {
                            var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                            window.history.replaceState({
                                path: t
                            }, "", t)
                        }
                    },
                    _updateMasterSelect: function(e) {
                        this.container.querySelector(this.originalSelectorId).value = e.id, this.container.querySelector(this.originalSelectorId).dispatchEvent(new Event("change", {
                            bubbles: !0
                        }))
                    }
                }), e
            }(), window.vimeoApiReady = function() {
                theme.config.vimeoLoading = !0, e().then(function() {
                    theme.config.vimeoReady = !0, theme.config.vimeoLoading = !1, document.dispatchEvent(new CustomEvent("vimeoReady"))
                })
            }, theme.VimeoPlayer = function() {
                function e(e, t, a) {
                    this.divId = e, this.el = document.getElementById(e), this.videoId = t, this.iframe = null, this.options = a, this.options && this.options.videoParent && (this.parent = this.el.closest(this.options.videoParent)), this.setAsLoading(), theme.config.vimeoReady ? this.init() : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady), document.addEventListener("vimeoReady", this.init.bind(this)))
                }
                var t = {
                        loading: "loading",
                        loaded: "loaded",
                        interactable: "video-interactable"
                    },
                    a = {
                        background: !0,
                        byline: !1,
                        controls: !1,
                        loop: !0,
                        muted: !0,
                        playsinline: !0,
                        portrait: !1,
                        title: !1
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        var e = a;
                        e.id = this.videoId, this.videoPlayer = new Vimeo.Player(this.el, e), this.videoPlayer.ready().then(this.playerReady.bind(this))
                    },
                    playerReady: function() {
                        this.iframe = this.el.querySelector("iframe"), this.iframe.setAttribute("tabindex", "-1"), this.videoPlayer.setMuted(!0), this.setAsLoaded();
                        var e = new IntersectionObserver(e => {
                            e.forEach(e => {
                                e.isIntersecting ? this.play() : this.pause()
                            })
                        }, {
                            rootMargin: "0px 0px 50px 0px"
                        });
                        e.observe(this.iframe)
                    },
                    setAsLoading: function() {
                        this.parent && this.parent.classList.add(t.loading)
                    },
                    setAsLoaded: function() {
                        this.parent && (this.parent.classList.remove(t.loading), this.parent.classList.add(t.loaded), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard())
                    },
                    enableInteraction: function() {
                        this.parent && this.parent.classList.add(t.interactable)
                    },
                    play: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play()
                    },
                    pause: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause()
                    },
                    destroy: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy()
                    }
                }), e
            }(), window.onYouTubeIframeAPIReady = function() {
                theme.config.youTubeReady = !0, document.dispatchEvent(new CustomEvent("youTubeReady"))
            }, theme.YouTube = function() {
                function e(e, t) {
                    this.divId = e, this.iframe = null, this.attemptedToPlay = !1, a.events = {
                        onReady: this.onVideoPlayerReady.bind(this),
                        onStateChange: this.onVideoStateChange.bind(this)
                    }, this.options = Object.assign({}, a, t), this.options && (this.options.videoParent && (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)), !this.options.autoplay && (this.options.playerVars.autoplay = this.options.autoplay), "sound" === this.options.style && (this.options.playerVars.controls = 1, this.options.playerVars.autoplay = 0)), this.setAsLoading(), theme.config.youTubeReady ? this.init() : (theme.LibraryLoader.load("youtubeSdk"), document.addEventListener("youTubeReady", this.init.bind(this)))
                }
                var t = {
                        loading: "loading",
                        loaded: "loaded",
                        interactable: "video-interactable"
                    },
                    a = {
                        width: 1280,
                        height: 720,
                        playerVars: {
                            autohide: 0,
                            autoplay: 1,
                            cc_load_policy: 0,
                            controls: 0,
                            fs: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            rel: 0
                        }
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.videoPlayer = new YT.Player(this.divId, this.options)
                    },
                    onVideoPlayerReady: function(e) {
                        this.iframe = document.getElementById(this.divId), this.iframe.setAttribute("tabindex", "-1"), "sound" !== this.options.style && e.target.mute();
                        var t = new IntersectionObserver(e => {
                            e.forEach(e => {
                                e.isIntersecting ? this.play() : this.pause()
                            })
                        }, {
                            rootMargin: "0px 0px 50px 0px"
                        });
                        t.observe(this.iframe)
                    },
                    onVideoStateChange: function(e) {
                        switch (e.data) {
                            case -1:
                                this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                                break;
                            case 0:
                                this.play(e);
                                break;
                            case 1:
                                this.setAsLoaded();
                                break;
                            case 3:
                                this.attemptedToPlay = !0;
                        }
                    },
                    setAsLoading: function() {
                        this.parent && this.parent.classList.add(t.loading)
                    },
                    setAsLoaded: function() {
                        this.parent && (this.parent.classList.remove(t.loading), this.parent.classList.add(t.loaded), Shopify && Shopify.designMode && window.AOS && AOS.refreshHard())
                    },
                    enableInteraction: function() {
                        this.parent && this.parent.classList.add(t.interactable)
                    },
                    play: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.playVideo && this.videoPlayer.playVideo()
                    },
                    pause: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.pauseVideo && this.videoPlayer.pauseVideo()
                    },
                    destroy: function() {
                        this.videoPlayer && "function" == typeof this.videoPlayer.destroy && this.videoPlayer.destroy()
                    }
                }), e
            }(),
            function() {
                var a, o = !1;
                document.body.addEventListener("touchstart", function(e) {
                    if (!e.target.closest(".flickity-slider")) {
                        return o = !1
                    }
                    o = !0, a = {
                        x: e.touches[0].pageX,
                        y: e.touches[0].pageY
                    }
                }), document.body.addEventListener("touchmove", function(e) {
                    if (o && e.cancelable) {
                        var t = {
                            x: e.touches[0].pageX - a.x,
                            y: e.touches[0].pageY - a.y
                        };
                        Math.abs(t.x) > Flickity.defaults.dragThreshold && e.preventDefault()
                    }
                }, {
                    passive: !1
                })
            }(), theme.AjaxRenderer = function() {
                function e({
                    sections: e,
                    onReplace: t,
                    debug: a
                } = {}) {
                    this.sections = e || [], this.cachedSections = [], this.onReplace = t, this.debug = !!a
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    renderPage: function(e, t, a = !0) {
                        const i = new URLSearchParams(window.location.search),
                            o = this.getUpdatedParams(i, t),
                            n = this.sections.map(t => {
                                const a = `${e}?section_id=${t.sectionId}&${o.toString()}`,
                                    i = e => e.url === a;
                                return this.cachedSections.some(i) ? this.renderSectionFromCache(i, t) : this.renderSectionFromFetch(a, t)
                            });
                        return a && this.updateURLHash(o), Promise.all(n)
                    },
                    renderSectionFromCache: function(e, t) {
                        const a = this.cachedSections.find(e);
                        return this.log(`[AjaxRenderer] rendering from cache: url=${a.url}`), this.renderSection(a.html, t), Promise.resolve(t)
                    },
                    renderSectionFromFetch: function(e, t) {
                        return this.log(`[AjaxRenderer] redering from fetch: url=${e}`), new Promise((a, i) => {
                            fetch(e).then(e => e.text()).then(i => {
                                const o = i;
                                this.cachedSections = [...this.cachedSections, {
                                    html: o,
                                    url: e
                                }], this.renderSection(o, t), a(t)
                            }).catch(e => i(e))
                        })
                    },
                    renderSection: function(e, t) {
                        this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`);
                        const a = new DOMParser().parseFromString(e, "text/html");
                        if (this.onReplace) this.onReplace(a, t);
                        else if ("string" == typeof t.nodeId) {
                            var i = a.getElementById(t.nodeId);
                            if (!i) return;
                            document.getElementById(t.nodeId).innerHTML = i.innerHTML
                        } else t.nodeId.forEach(e => {
                            document.getElementById(e).innerHTML = a.getElementById(e).innerHTML
                        });
                        return t
                    },
                    getUpdatedParams: function(e, t) {
                        const a = new URLSearchParams(e),
                            i = ["sort_by", "q", "options[prefix]", "type"];
                        for (const [o, n] of a.entries()) t.getAll(o).includes(n) || i.includes(o) || a.delete(o);
                        for (const [i, o] of t.entries()) a.getAll(i).includes(o) || "" === o || a.append(i, o);
                        return a
                    },
                    updateURLHash: function(e) {
                        history.pushState({}, "", `${window.location.pathname}${e&&"?".concat(e)}`)
                    },
                    log: function(...e) {
                        this.debug && console.log(...e)
                    }
                }), e
            }(), window.Shopify && window.Shopify.theme && navigator && navigator.sendBeacon && window.Shopify.designMode && navigator.sendBeacon("https://api.archetypethemes.co/api/beacon", new URLSearchParams({
                shop: window.Shopify.shop,
                themeName: window.theme && window.theme.settings && `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
                role: window.Shopify.theme.role,
                route: window.location.pathname,
                themeId: window.Shopify.theme.id,
                themeStoreId: window.Shopify.theme.theme_store_id || 0,
                isThemeEditor: !!window.Shopify.designMode
            })), theme.cart = {
                getCart: function() {
                    var e = "".concat(theme.routes.cart, "?t=").concat(Date.now());
                    return fetch(e, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(e => e.json())
                },
                getCartProductMarkup: function() {
                    var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
                    return e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax", fetch(e, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        return e.text()
                    })
                },
                changeItem: function(e, t) {
                    return this._updateCart({
                        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                        data: JSON.stringify({
                            id: e,
                            quantity: t
                        })
                    })
                },
                _updateCart: function(e) {
                    return fetch(e.url, {
                        method: "POST",
                        body: e.data,
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(e => e.json()).then(function(e) {
                        return e
                    })
                },
                updateAttribute: function(e, t) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({
                            attributes: {
                                [e]: theme.cart.attributeToString(t)
                            }
                        })
                    })
                },
                updateNote: function(e) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({
                            note: theme.cart.attributeToString(e)
                        })
                    })
                },
                attributeToString: function(e) {
                    return "string" != typeof e && (e += "", "undefined" === e && (e = "")), e.trim()
                }
            }, 
            theme.CartForm = function() {
                function e(e) {
                    e && (this.form = e, 
                    this.wrapper = e.parentNode, 
                    this.location = e.dataset.location, 
                    this.namespace = ".cart-" + this.location, 
                    this.products = e.querySelector(t.products), 
                    this.submitBtn = e.querySelector(t.checkoutBtn), 
                    this.discounts = e.querySelector(t.discounts), 
                    this.savings = e.querySelector(t.savings), 
                    this.subtotal = e.querySelector(t.subTotal), 
                    this.termsCheckbox = e.querySelector(t.termsCheckbox), 
                    this.noteInput = e.querySelector(t.cartNote), 
                    this.freeShipping = e.querySelector(t.freeshipping), 
                    this.upsellProducts = e.querySelector(t.upsellProducts), 
                    this.termsCheckbox && (i.requiresTerms = !0), 
                    this.init())
                }
                var t = {
                        products: "[data-products]",
                        qtySelector: ".js-qty__wrapper",
                        discounts: "[data-discounts]",
                        savings: "[data-savings]",
                        subTotal: "[data-subtotal]",
                        cartBubble: ".cart-link__bubble",
                        cartNote: "[name=\"note\"]",
                        termsCheckbox: ".cart__terms-checkbox",
                        checkoutBtn: ".cart__checkout",
                        freeshipping: "[data-free-shipping]",
                        upsellProducts: "[data-upsell-products]"
                    },
                    a = {
                        btnLoading: "btn--loading"
                    },
                    i = {
                        requiresTerms: !1
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.initQtySelectors(), document.addEventListener("cart:quantity" + this.namespace, this.quantityChanged.bind(this)), this.form.on("submit" + this.namespace, this.onSubmit.bind(this)), this.noteInput && this.noteInput.addEventListener("change", function() {
                            var e = this.value;
                            theme.cart.updateNote(e)
                        }), document.addEventListener("cart:build", function() {
                            this.buildCart()
                        }.bind(this))
                    },
                    reInit: function() {
                        this.initQtySelectors()
                    },
                    onSubmit: function(e) {
                        if (this.submitBtn.classList.add(a.btnLoading), i.requiresTerms)
                            if (this.termsCheckbox.checked);
                            else return alert(theme.strings.cartTermsConfirmation), this.submitBtn.classList.remove(a.btnLoading), e.preventDefault(), !1
                    },
                    _parseProductHTML: function(e) {
                        var t = new DOMParser,
                            a = t.parseFromString(e, "text/html");
                        return {
                            items: a.querySelector(".cart__items"),
                            upsell: a.querySelector(".cart-upsell-products"),
                            discounts: a.querySelector(".cart__discounts"),
                            shippingBar: a.querySelector(".shipping-progress-main")
                        }
                    },
                    buildCart: function() {
                        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this))
                    },
                    cartMarkup: function(e) {
                        var t = this._parseProductHTML(e);
                        var a = t.items;
                        var i = parseInt(a.dataset.count);
                        var o = a.dataset.cartSubtotal;
                        var n = a.dataset.cartSavings;
                        var s = t.shippingBar;
                        var up = t.upsell;

                        this.updateCartDiscounts(t.discounts);

                        this.updateSavings(n);

                        if (i > 0) {
                            this.wrapper.classList.remove("is-empty");
                        } else {
                            this.wrapper.classList.add("is-empty");
                        }

                        this.updateCount(i);

                        // Drawer title count update
                        var drawerCount = document.querySelector(
                            "[data-drawer-cart-count]"
                        );

                        if (drawerCount) {
                            drawerCount.innerText = i;
                        }

                        this.products.innerHTML = "";
                        this.products.append(a);

                        this.subtotal.innerHTML = theme.Currency.formatMoney(
                            o,
                            theme.settings.moneyFormat
                        );

                        // Shipping bar update
                        this.freeShipping.innerHTML="";
                        this.freeShipping.append(s);

                        // Upsell Update
                        this.upsellProducts.innerHTML="";
                        this.upsellProducts.append(up);

                        this.reInit();

                        if (window.AOS) {
                            AOS.refreshHard();
                        }

                        if ( window.Shopify && Shopify.StorefrontExpressButtons ) {
                            Shopify.StorefrontExpressButtons.initialize();
                        }
                    },

                    updateCartDiscounts: function(e) {
                        this.discounts && (this.discounts.innerHTML = "", this.discounts.append(e))
                    },

                    initQtySelectors: function() {
                        this.form.querySelectorAll(t.qtySelector).forEach(e => {
                            new theme.QtySelector(e, {
                                namespace: this.namespace,
                                isCart: !0
                            })
                        })
                    },
                    quantityChanged: function(e) {
                        var t = e.detail[0],
                            a = e.detail[1],
                            i = e.detail[2];
                        t && a && (i && i.classList.add("is-loading"), theme.cart.changeItem(t, a).then(function(e) {
                            0 < e.item_count ? this.wrapper.classList.remove("is-empty") : this.wrapper.classList.add("is-empty"), this.buildCart(), document.dispatchEvent(new CustomEvent("cart:updated", {
                                detail: {
                                    cart: e
                                }
                            }))
                        }.bind(this)).catch(function() {}))
                    },
                    updateSubtotal: function(e) {
                        this.form.querySelector(t.subTotal).innerHTML = theme.Currency.formatMoney(e, theme.settings.moneyFormat)
                    },
                    updateSavings: function(e) {
                        if (this.savings)
                            if (0 < e) {
                                var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                                this.savings.classList.remove("hide"), this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", t)
                            } else this.savings.classList.add("hide")
                    },
                    updateCount: function(e) {
                        var a = document.querySelectorAll(".cart-link__bubble-num");
                        a.length && a.forEach(t => {
                            t.innerText = e
                        });
                        var i = document.querySelectorAll(t.cartBubble);
                        i.length && (0 < e ? i.forEach(e => {
                            e.classList.add("cart-link__bubble--visible")
                        }) : i.forEach(e => {
                            e.classList.remove("cart-link__bubble--visible")
                        }))
                    }
                }), e
            }(), theme.collapsibles = function() {
                function e(e) {
                    if (!o) {
                        o = !0;
                        var n = e.currentTarget,
                            r = n.classList.contains(i.open),
                            s = n.classList.contains(i.tabs),
                            l = n.getAttribute("aria-controls"),
                            d = document.getElementById(l);
                        if (l || (l = n.dataset.controls), !!l) {
                            if (!d) {
                                var c = document.querySelectorAll("[data-id=\"" + l + "\"]");
                                0 < c.length && (d = n.parentNode.querySelector("[data-id=\"" + l + "\"]"))
                            }
                            if (!d) return void(o = !1);
                            var u = d.querySelector(a.moduleInner).offsetHeight,
                                p = d.classList.contains(i.autoHeight),
                                m = d.parentNode.closest(a.module),
                                g = u;
                            if (s) {
                                if (r) return void(o = !1);
                                var y;
                                document.querySelectorAll(a.tabs + "[data-id=\"" + n.dataset.id + "\"]").forEach(e => {
                                    e.classList.remove(i.open), y = document.querySelector("#" + e.getAttribute("aria-controls")), t(y, 0, !0)
                                })
                            }
                            if (r && p && setTimeout(function() {
                                    u = 0, t(d, u, r, p)
                                }, 0), r && !p && (u = 0), n.setAttribute("aria-expanded", !r), r ? n.classList.remove(i.open) : n.classList.add(i.open), t(d, u, r, p), m) {
                                var h = m.style.height;
                                r && "auto" === h && (g = 0);
                                var v = r ? m.offsetHeight - g : u + m.offsetHeight;
                                t(m, v, !1, !1)
                            }
                            if (window.SPR) {
                                var f = d.querySelector(".spr-summary-actions-newreview");
                                if (!f) return;
                                f.off("click.collapsible"), f.on("click.collapsible", function() {
                                    u = d.querySelector(a.moduleInner).offsetHeight, t(d, u, r, p)
                                })
                            }
                        }
                    }
                }

                function t(e, t, a, n) {
                    if (e.classList.remove(i.hide), theme.utils.prepareTransition(e, function() {
                            e.style.height = t + "px", a ? e.classList.remove(i.open) : e.classList.add(i.open)
                        }), !a && n) {
                        window.setTimeout(function() {
                            e.css("height", "auto"), o = !1
                        }, 500)
                    } else o = !1
                }
                var a = {
                        trigger: ".collapsible-trigger",
                        module: ".collapsible-content",
                        moduleInner: ".collapsible-content__inner",
                        tabs: ".collapsible-trigger--tab"
                    },
                    i = {
                        hide: "hide",
                        open: "is-open",
                        autoHeight: "collapsible--auto-height",
                        tabs: "collapsible-trigger--tab"
                    },
                    o = !1;
                return {
                    init: function(t) {
                        var o = t ? t : document;
                        o.querySelectorAll(a.trigger).forEach(t => {
                            var a = t.classList.contains(i.open);
                            t.setAttribute("aria-expanded", a), t.off("click.collapsible"), t.on("click.collapsible", e)
                        })
                    }
                }
            }(), theme.Disclosure = function() {
                function e(e) {
                    this.container = e, this._cacheSelectors(), this._setupListeners()
                }
                var t = {
                        disclosureForm: "[data-disclosure-form]",
                        disclosureList: "[data-disclosure-list]",
                        disclosureToggle: "[data-disclosure-toggle]",
                        disclosureInput: "[data-disclosure-input]",
                        disclosureOptions: "[data-disclosure-option]"
                    },
                    a = {
                        listVisible: "disclosure-list--visible"
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    _cacheSelectors: function() {
                        this.cache = {
                            disclosureForm: this.container.closest(t.disclosureForm),
                            disclosureList: this.container.querySelector(t.disclosureList),
                            disclosureToggle: this.container.querySelector(t.disclosureToggle),
                            disclosureInput: this.container.querySelector(t.disclosureInput),
                            disclosureOptions: this.container.querySelectorAll(t.disclosureOptions)
                        }
                    },
                    _setupListeners: function() {
                        this.eventHandlers = this._setupEventHandlers(), this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function(e) {
                            e.addEventListener("click", this.eventHandlers.connectOptions)
                        }, this), this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.addEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.addEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.addEventListener("click", this.eventHandlers.onBodyClick)
                    },
                    _setupEventHandlers: function() {
                        return {
                            connectOptions: this._connectOptions.bind(this),
                            toggleList: this._toggleList.bind(this),
                            onBodyClick: this._onBodyClick.bind(this),
                            onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                            onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                            onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
                        }
                    },
                    _connectOptions: function(e) {
                        e.preventDefault(), this._submitForm(e.currentTarget.dataset.value)
                    },
                    _onDisclosureToggleFocusOut: function(e) {
                        var t = !1 === this.container.contains(e.relatedTarget);
                        t && this._hideList()
                    },
                    _onDisclosureListFocusOut: function(e) {
                        var t = e.currentTarget.contains(e.relatedTarget),
                            i = this.cache.disclosureList.classList.contains(a.listVisible);
                        i && !t && this._hideList()
                    },
                    _onDisclosureKeyUp: function(e) {
                        27 !== e.which || (this._hideList(), this.cache.disclosureToggle.focus())
                    },
                    _onBodyClick: function(e) {
                        var t = this.container.contains(e.target),
                            i = this.cache.disclosureList.classList.contains(a.listVisible);
                        i && !t && this._hideList()
                    },
                    _submitForm: function(e) {
                        this.cache.disclosureInput.value = e, this.cache.disclosureForm.submit()
                    },
                    _hideList: function() {
                        this.cache.disclosureList.classList.remove(a.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !1)
                    },
                    _toggleList: function() {
                        var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                        this.cache.disclosureList.classList.toggle(a.listVisible), this.cache.disclosureToggle.setAttribute("aria-expanded", !e)
                    },
                    destroy: function() {
                        this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList), this.cache.disclosureOptions.forEach(function(e) {
                            e.removeEventListener("click", this.eventHandlers.connectOptions)
                        }, this), this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp), this.cache.disclosureList.removeEventListener("focusout", this.eventHandlers.onDisclosureListFocusOut), this.cache.disclosureToggle.removeEventListener("focusout", this.eventHandlers.onDisclosureToggleFocusOut), document.body.removeEventListener("click", this.eventHandlers.onBodyClick)
                    }
                }), e
            }(), theme.Drawers = function() {
                function e(e, t) {
                    this.config = {
                        id: e,
                        close: ".js-drawer-close",
                        open: ".js-drawer-open-" + t,
                        openClass: "js-drawer-open",
                        closingClass: "js-drawer-closing",
                        activeDrawer: "drawer--is-open",
                        namespace: ".drawer-" + t
                    }, this.nodes = {
                        page: document.querySelector("#MainContent")
                    }, this.drawer = document.querySelector("#" + e), this.isOpen = !1, this.drawer && this.init()
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        document.querySelectorAll(this.config.open).forEach(e => {
                            e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this))
                        }), this.drawer.querySelector(this.config.close).addEventListener("click", this.close.bind(this)), document.addEventListener("modalOpen", function() {
                            this.close()
                        }.bind(this))
                    },
                    open: function(e, t) {
                        e && e.preventDefault(), this.isOpen || (e && e.stopPropagation ? (e.stopPropagation(), e.currentTarget.setAttribute("aria-expanded", "true"), this.activeSource = e.currentTarget) : t && (t.setAttribute("aria-expanded", "true"), this.activeSource = t), theme.utils.prepareTransition(this.drawer, function() {
                            this.drawer.classList.add(this.config.activeDrawer)
                        }.bind(this)), document.documentElement.classList.add(this.config.openClass), this.isOpen = !0, theme.a11y.trapFocus({
                            container: this.drawer,
                            namespace: "drawer_focus"
                        }), document.dispatchEvent(new CustomEvent("drawerOpen")), document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)), this.bindEvents())
                    },
                    close: function(e) {
                        if (this.isOpen) {
                            if (e)
                                if (e.target.closest(".js-drawer-close"));
                                else if (e.target.closest(".drawer")) return;
                            document.activeElement.blur(), theme.utils.prepareTransition(this.drawer, function() {
                                this.drawer.classList.remove(this.config.activeDrawer)
                            }.bind(this)), document.documentElement.classList.remove(this.config.openClass), document.documentElement.classList.add(this.config.closingClass), window.setTimeout(function() {
                                document.documentElement.classList.remove(this.config.closingClass), this.activeSource && this.activeSource.getAttribute("aria-expanded") && (this.activeSource.setAttribute("aria-expanded", "false"), this.activeSource.focus())
                            }.bind(this), 500), this.isOpen = !1, theme.a11y.removeTrapFocus({
                                container: this.drawer,
                                namespace: "drawer_focus"
                            }), this.unbindEvents()
                        }
                    },
                    bindEvents: function() {
                        window.on("click" + this.config.namespace, function(e) {
                            this.close(e)
                        }.bind(this)), window.on("keyup" + this.config.namespace, function(e) {
                            27 === e.keyCode && this.close()
                        }.bind(this)), theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page)
                    },
                    unbindEvents: function() {
                        window.off("click" + this.config.namespace), window.off("keyup" + this.config.namespace), theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page)
                    }
                }), e
            }(), theme.Modals = function() {
                function e(e, t, a) {
                    return this.id = e, this.modal = document.getElementById(e), !!this.modal && void(this.modalContent = this.modal.querySelector(".modal__inner"), this.config = Object.assign({
                        close: ".js-modal-close",
                        open: ".js-modal-open-" + t,
                        openClass: "modal--is-active",
                        closingClass: "modal--is-closing",
                        bodyOpenClass: ["modal-open"],
                        bodyOpenSolidClass: "modal-open--solid",
                        bodyClosingClass: "modal-closing",
                        closeOffContentClick: !0
                    }, a), this.modalIsOpen = !1, this.focusOnOpen = this.config.focusIdOnOpen ? document.getElementById(this.config.focusIdOnOpen) : this.modal, this.isSolid = this.config.solid, this.init())
                }
                return e.prototype.init = function() {
                    document.querySelectorAll(this.config.open).forEach(e => {
                        e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this))
                    }), this.modal.querySelectorAll(this.config.close).forEach(e => {
                        e.addEventListener("click", this.close.bind(this))
                    }), document.addEventListener("drawerOpen", function() {
                        this.close()
                    }.bind(this))
                }, e.prototype.open = function(e) {
                    var t = !1;
                    this.modalIsOpen || (e ? e.preventDefault() : t = !0, e && e.stopPropagation && (e.stopPropagation(), this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true")), this.modalIsOpen && !t && this.close(), this.modal.classList.add(this.config.openClass), document.documentElement.classList.add(...this.config.bodyOpenClass), this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass), this.modalIsOpen = !0, theme.a11y.trapFocus({
                        container: this.modal,
                        elementToFocus: this.focusOnOpen,
                        namespace: "modal_focus"
                    }), document.dispatchEvent(new CustomEvent("modalOpen")), document.dispatchEvent(new CustomEvent("modalOpen." + this.id)), this.bindEvents())
                }, e.prototype.close = function(e) {
                    if (this.modalIsOpen) {
                        if (e)
                            if (e.target.closest(".js-modal-close"));
                            else if (e.target.closest(".modal__inner")) return;
                        document.activeElement.blur(), this.modal.classList.remove(this.config.openClass), this.modal.classList.add(this.config.closingClass), document.documentElement.classList.remove(...this.config.bodyOpenClass), document.documentElement.classList.add(this.config.bodyClosingClass), window.setTimeout(function() {
                            document.documentElement.classList.remove(this.config.bodyClosingClass), this.modal.classList.remove(this.config.closingClass), this.activeSource && this.activeSource.getAttribute("aria-expanded") && this.activeSource.setAttribute("aria-expanded", "false").focus()
                        }.bind(this), 500), this.isSolid && document.documentElement.classList.remove(this.config.bodyOpenSolidClass), this.modalIsOpen = !1, theme.a11y.removeTrapFocus({
                            container: this.modal,
                            namespace: "modal_focus"
                        }), document.dispatchEvent(new CustomEvent("modalClose." + this.id)), this.unbindEvents()
                    }
                }, e.prototype.bindEvents = function() {
                    window.on("keyup.modal", function(e) {
                        27 === e.keyCode && this.close()
                    }.bind(this)), this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this))
                }, e.prototype.unbindEvents = function() {
                    document.documentElement.off(".modal"), this.config.closeOffContentClick && this.modal.off(".modal")
                }, e
            }();
        class t extends HTMLElement {
            constructor() {
                super(), this.parallaxImage = this.querySelector("[data-parallax-image]"), this.windowInnerHeight = window.innerHeight, this.isActive = !1, this.timeout = null, this.directionMap = {
                    right: 0,
                    top: 90,
                    left: 180,
                    bottom: 270
                }, this.directionMultipliers = {
                    0: [1, 0],
                    90: [0, -1],
                    180: [-1, 0],
                    270: [0, 1]
                }, this.init(), window.addEventListener("scroll", () => this.scrollHandler())
            }
            getParallaxInfo() {
                const {
                    width: e,
                    height: t,
                    top: a
                } = this.parallaxImage.getBoundingClientRect();
                let i, o = this.parallaxImage,
                    {
                        angle: n,
                        movement: r
                    } = o.dataset,
                    s = "top" === n ? Math.ceil(t * (parseFloat(r) / 100)) : Math.ceil(e * (parseFloat(r) / 100));
                    n = this.directionMap[n] ?? parseFloat(n), n !== n && (n = 270), s !== s && (s = 100), n %= 360, 0 > n && (n += 360);
                const l = 90 < n && 270 > n,
                    d = 180 > n;
                if (o.style[l ? "left" : "right"] = 0, o.style[d ? "top" : "bottom"] = 0, n % 90) {
                    const e = n * Math.PI / 180;
                    i = [Math.cos(e), -1 * Math.sin(e)]
                } else i = this.directionMultipliers[n];
                return i[0] && (o.style.width = `calc(100% + ${s*Math.abs(i[0])}px)`), i[1] && (o.style.height = `calc(100% + ${s*Math.abs(i[1])}px)`), {
                    element: o,
                    movementPixels: s,
                    multipliers: i,
                    top: a,
                    height: t
                }
            }
            init() {
                const {
                    element: e,
                    movementPixels: t,
                    multipliers: a,
                    top: i,
                    height: o
                } = this.getParallaxInfo(), n = this.windowInnerHeight - i, r = this.windowInnerHeight + o, s = n / r;
                if (-.1 < s && 1.1 > s) {
                    const i = Math.min(Math.max(s, 0), 1) * t;
                    e.style.transform = `translate3d(${i*a[0]}px, ${i*a[1]}px, 0)`
                }
                this.isActive && requestAnimationFrame(this.init.bind(this))
            }
            scrollHandler() {
                this.isActive ? clearTimeout(this.timeout) : (this.isActive = !0, requestAnimationFrame(this.init.bind(this))), this.timeout = setTimeout(() => this.isActive = !1, 20)
            }
        }
        if (customElements.define("parallax-image", t), "undefined" == typeof window.noUiSlider) throw new Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        theme.PriceRange = function() {
            function e(e, {
                onChange: t,
                onUpdate: a,
                ...i
            } = {}) {
                return this.container = e, this.onChange = t, this.onUpdate = a, this.sliderOptions = i || {}, this.init()
            }
            var t = {
                priceRange: ".price-range",
                priceRangeSlider: ".price-range__slider",
                priceRangeInputMin: ".price-range__input-min",
                priceRangeInputMax: ".price-range__input-max",
                priceRangeDisplayMin: ".price-range__display-min",
                priceRangeDisplayMax: ".price-range__display-max"
            };
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    if (!this.container.classList.contains("price-range")) throw new Error("You must instantiate PriceRange with a valid container");
                    return this.formEl = this.container.closest("form"), this.sliderEl = this.container.querySelector(t.priceRangeSlider), this.inputMinEl = this.container.querySelector(t.priceRangeInputMin), this.inputMaxEl = this.container.querySelector(t.priceRangeInputMax), this.displayMinEl = this.container.querySelector(t.priceRangeDisplayMin), this.displayMaxEl = this.container.querySelector(t.priceRangeDisplayMax), this.minRange = parseFloat(this.container.dataset.min) || 0, this.minValue = parseFloat(this.container.dataset.minValue) || 0, this.maxRange = parseFloat(this.container.dataset.max) || 100, this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange, this.createPriceRange()
                },
                createPriceRange: function() {
                    this.sliderEl && this.sliderEl.noUiSlider && "function" == typeof this.sliderEl.noUiSlider.destroy && this.sliderEl.noUiSlider.destroy();
                    var e = noUiSlider.create(this.sliderEl, {
                        connect: !0,
                        step: 10,
                        ...this.sliderOptions,
                        start: [this.minValue, this.maxValue],
                        range: {
                            min: this.minRange,
                            max: this.maxRange
                        }
                    });
                    return e.on("update", e => {
                        this.displayMinEl.innerHTML = theme.Currency.formatMoney(e[0], theme.settings.moneyFormat), this.displayMaxEl.innerHTML = theme.Currency.formatMoney(e[1], theme.settings.moneyFormat), this.onUpdate && this.onUpdate(e)
                    }), e.on("change", e => {
                        if (this.inputMinEl.value = e[0], this.inputMaxEl.value = e[1], this.onChange) {
                            const e = new FormData(this.formEl);
                            this.onChange(e)
                        }
                    }), e
                }
            }), e
        }(), theme.AjaxProduct = function() {
            function e(e, t, a) {
                this.form = e, this.args = a;
                var i = t ? t : ".add-to-cart";
                this.form && (this.addToCart = e.querySelector(i), this.form.addEventListener("submit", this.addItemFromForm.bind(this)))
            }
            var t = {
                loading: !1
            };
            return e.prototype = Object.assign({}, e.prototype, {
                addItemFromForm: function(e) {
                    if (e.preventDefault(), !t.loading) {
                        this.addToCart.classList.add("btn--loading"), t.loading = !0;
                        var a = theme.utils.serialize(this.form);
                        fetch(theme.routes.cartAdd, {
                            method: "POST",
                            body: a,
                            credentials: "same-origin",
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(e => e.json()).then(function(e) {
                            if (422 === e.status) this.error(e);
                            else {
                                this.success(e)
                            }
                            t.loading = !1, this.addToCart.classList.remove("btn--loading"), document.body.classList.contains("template-cart") && (window.scrollTo(0, 0), location.reload())
                        }.bind(this))
                    }
                },
                success: function(e) {
                    var t = this.form.querySelector(".errors");
                    t && t.remove(), document.dispatchEvent(new CustomEvent("ajaxProduct:added", {
                        detail: {
                            product: e,
                            addToCartBtn: this.addToCart
                        }
                    })), this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
                        detail: {
                            product: e,
                            addToCartBtn: this.addToCart
                        }
                    }))
                },
                error: function(e) {
                    if (!e.description) return void console.warn(e);
                    var t = this.form.querySelector(".errors");
                    t && t.remove();
                    var a = document.createElement("div");
                    a.classList.add("errors", "text-center"), a.textContent = e.description, this.form.append(a), document.dispatchEvent(new CustomEvent("ajaxProduct:error", {
                        detail: {
                            errorMessage: e.description
                        }
                    })), this.args && this.args.scopedEventId && document.dispatchEvent(new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
                        detail: {
                            errorMessage: e.description
                        }
                    }))
                }
            }), e
        }(), theme.ProductMedia = function() {
            function e(t) {
                if (!t) {
                    if (!window.ShopifyXR) return void document.addEventListener("shopify_xr_initialized", function() {
                        e()
                    });
                    for (var a in i)
                        if (i.hasOwnProperty(a)) {
                            var o = i[a];
                            if (o.loaded) continue;
                            var n = document.querySelector("#ModelJson-" + a);
                            window.ShopifyXR.addModels(JSON.parse(n.innerHTML)), o.loaded = !0
                        } window.ShopifyXR.setupXRElements()
                }
            }

            function t(e) {
                if (!e)
                    for (var t in o)
                        if (o.hasOwnProperty(t)) {
                            var i = o[t];
                            !i.modelViewerUi && Shopify && (i.modelViewerUi = new Shopify.ModelViewerUI(i.element)), a(i)
                        }
            }

            function a(e) {
                var t = n[e.sectionId];
                e.container.addEventListener("mediaVisible", function() {
                    t.element.setAttribute("data-shopify-model3d-id", e.modelId), theme.config.isTouch || e.modelViewerUi.play()
                }), e.container.addEventListener("mediaHidden", function() {
                    t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause()
                }), e.container.addEventListener("xrLaunch", function() {
                    e.modelViewerUi.pause()
                })
            }
            var i = {},
                o = {},
                n = {},
                r = {
                    mediaGroup: "[data-product-single-media-group]",
                    xrButton: "[data-shopify-xr]"
                };
            return {
                init: function(a, s) {
                    i[s] = {
                        loaded: !1
                    }, a.forEach(function(e, t) {
                        var a = e.dataset.mediaId,
                            i = e.querySelector("model-viewer"),
                            l = i.dataset.modelId;
                        if (0 === t) {
                            var d = e.closest(r.mediaGroup),
                                c = d.querySelector(r.xrButton);
                            n[s] = {
                                element: c,
                                defaultId: l
                            }
                        }
                        o[a] = {
                            modelId: l,
                            sectionId: s,
                            container: e,
                            element: i
                        }
                    }), window.Shopify.loadFeatures([{
                        name: "shopify-xr",
                        version: "1.0",
                        onLoad: e
                    }, {
                        name: "model-viewer-ui",
                        version: "1.0",
                        onLoad: t
                    }]), theme.LibraryLoader.load("modelViewerUiStyles")
                },
                removeSectionModels: function(e) {
                    for (var t in o)
                        if (o.hasOwnProperty(t)) {
                            var a = o[t];
                            a.sectionId === e && delete o[t]
                        } delete i[e]
                }
            }
        }(), theme.QtySelector = function() {
            function e(e, a) {
                this.wrapper = e, 
                this.plus = e.querySelector(t.plus), 
                this.minus = e.querySelector(t.minus), 
                this.input = e.querySelector(t.input),
                this.minValue = this.input.getAttribute("min") || 1;

                var i = {
                    namespace: null,
                    isCart: !1,
                    key: this.input.dataset.id
                };
                this.options = Object.assign({}, i, a), this.init()
            }
            var t = {
                input: ".js-qty__num",
                plus: ".js-qty__adjust--plus",
                minus: ".js-qty__adjust--minus"
            };
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    this.plus.addEventListener("click", function() {
                        var e = this._getQty();
                        this._change(e + 1)
                    }.bind(this)), this.minus.addEventListener("click", function() {
                        var e = this._getQty();
                        this._change(e - 1)
                    }.bind(this)), this.input.addEventListener("change", function() {
                        this._change(this._getQty())
                    }.bind(this))
                },
                _getQty: function() {
                    var e = this.input.value;
                    return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e)
                },
                _change: function(e) {
                    e <= this.minValue && (e = this.minValue), this.input.value = e, this.options.isCart && document.dispatchEvent(new CustomEvent("cart:quantity" + this.options.namespace, {
                        detail: [this.options.key, e, this.wrapper]
                    }))
                }
            }), e
        }(), theme.initQuickShop = function() {
            function e(t) {
                var a = t.currentTarget;
                if (!theme.config.bpSmall) {
                    if (a.removeEventListener("mouseover", e), !a || !a.dataset.productId) return;
                    var i = a.dataset.productId,
                        o = a.dataset.productHandle,
                        n = a.querySelector(".quick-product__btn");
                    theme.preloadProductModal(o, i, n)
                }
            }
            var t = document.querySelectorAll(".grid-product");
            t.length && theme.settings.quickView && t.forEach(t => {
                t.addEventListener("mouseover", e)
            })
        }, theme.preloadProductModal = function(e, t, a) {
            var i = document.getElementById("QuickShopHolder-" + e),
                o = theme.routes.home + "/products/" + e + "?view=modal";
            o = o.replace("//", "/"), fetch(o).then(function(e) {
                return e.text()
            }).then(function(o) {
                var n = new DOMParser,
                    r = n.parseFromString(o, "text/html"),
                    s = r.querySelector(".product-section[data-product-handle=\"" + e + "\"]");
                if (i) {
                    i.innerHTML = "", i.append(s);
                    new theme.Modals("QuickShopModal-" + t, "quick-modal-" + t), theme.sections.register("product", theme.Product, i), theme.collapsibles.init(), theme.videoModal(), a && a.classList.remove("quick-product__btn--not-ready")
                }
            })
        }, theme.Slideshow = function() {
            function e(e, t) {
                if (this.el = e, this.args = Object.assign({}, o, t), this.args.on = {
                        ready: this.init.bind(this),
                        change: this.slideChange.bind(this),
                        settle: this.afterChange.bind(this)
                    }, this.args.childNav && (this.childNavEls = this.args.childNav.querySelectorAll(i.thumb), this.childNavLinks = this.args.childNav.querySelectorAll(i.links), this.arrows = this.args.childNav.querySelectorAll(i.arrow), this.childNavLinks.length && this.initChildNav()), this.args.avoidReflow && function(e) {
                        if (e.id) {
                            for (var t = e.firstChild; null != t && 3 == t.nodeType;) t = t.nextSibling;
                            var a = document.createElement("style");
                            a.innerHTML = `#${e.id} .flickity-viewport{height:${t.offsetHeight}px}`, document.head.appendChild(a)
                        }
                    }(e), this.slideshow = new Flickity(e, this.args), this.args.autoPlay) {
                    var n = e.closest(a.wrapper);
                    this.pauseBtn = n.querySelector(a.pauseButton), this.pauseBtn && this.pauseBtn.addEventListener("click", this._togglePause.bind(this))
                }
                window.on("resize", theme.utils.debounce(300, function() {
                    this.resize()
                }.bind(this)))
            }
            var t = {
                    animateOut: "animate-out",
                    isPaused: "is-paused",
                    isActive: "is-active"
                },
                a = {
                    allSlides: ".slideshow__slide",
                    currentSlide: ".is-selected",
                    wrapper: ".slideshow-wrapper",
                    pauseButton: ".slideshow__pause"
                },
                i = {
                    thumb: ".product__thumb-item:not(.hide)",
                    links: ".product__thumb-item:not(.hide) a",
                    arrow: ".product__thumb-arrow"
                },
                o = {
                    adaptiveHeight: !1,
                    autoPlay: !1,
                    avoidReflow: !1,
                    childNav: null,
                    childNavScroller: null,
                    childVertical: !1,
                    dragThreshold: 7,
                    fade: !1,
                    friction: .8,
                    initialIndex: 0,
                    pageDots: !1,
                    pauseAutoPlayOnHover: !1,
                    prevNextButtons: !1,
                    rightToLeft: theme.config.rtl,
                    selectedAttraction: .14,
                    setGallerySize: !0,
                    wrapAround: !0
                };
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    this.currentSlide = this.el.querySelector(a.currentSlide), this.args.callbacks && this.args.callbacks.onInit && "function" == typeof this.args.callbacks.onInit && this.args.callbacks.onInit(this.currentSlide), window.AOS && AOS.refresh()
                },
                slideChange: function(e) {
                    this.args.fade && this.currentSlide && (this.currentSlide.classList.add(t.animateOut), this.currentSlide.addEventListener("transitionend", function() {
                        this.currentSlide.classList.remove(t.animateOut)
                    }.bind(this))), this.args.childNav && this.childNavGoTo(e), this.args.callbacks && this.args.callbacks.onChange && "function" == typeof this.args.callbacks.onChange && this.args.callbacks.onChange(e), this.arrows && this.arrows.length && (this.arrows[0].classList.toggle("hide", 0 === e), this.arrows[1].classList.toggle("hide", e === this.childNavLinks.length - 1))
                },
                afterChange: function() {
                    this.args.fade && this.el.querySelectorAll(a.allSlides).forEach(e => {
                        e.classList.remove(t.animateOut)
                    }), this.currentSlide = this.el.querySelector(a.currentSlide), this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex)
                },
                destroy: function() {
                    this.args.childNav && this.childNavLinks.length && this.childNavLinks.forEach(e => {
                        e.classList.remove(t.isActive)
                    }), this.slideshow.destroy()
                },
                reposition: function() {
                    this.slideshow.reposition()
                },
                _togglePause: function() {
                    this.pauseBtn.classList.contains(t.isPaused) ? (this.pauseBtn.classList.remove(t.isPaused), this.slideshow.playPlayer()) : (this.pauseBtn.classList.add(t.isPaused), this.slideshow.pausePlayer())
                },
                resize: function() {
                    this.slideshow.resize()
                },
                play: function() {
                    this.slideshow.playPlayer()
                },
                pause: function() {
                    this.slideshow.pausePlayer()
                },
                goToSlide: function(e) {
                    this.slideshow.select(e)
                },
                setDraggable: function(e) {
                    this.slideshow.options.draggable = e, this.slideshow.updateDraggable()
                },
                initChildNav: function() {
                    this.childNavLinks[this.args.initialIndex].classList.add("is-active"), this.childNavLinks.forEach((e, t) => {
                        e.setAttribute("data-index", t), e.addEventListener("click", function(e) {
                            e.preventDefault(), this.goToSlide(this.getChildIndex(e.currentTarget))
                        }.bind(this)), e.addEventListener("focus", function(e) {
                            this.goToSlide(this.getChildIndex(e.currentTarget))
                        }.bind(this)), e.addEventListener("keydown", function(e) {
                            13 === e.keyCode && this.goToSlide(this.getChildIndex(e.currentTarget))
                        }.bind(this))
                    }), this.arrows.length && this.arrows.forEach(e => {
                        e.addEventListener("click", this.arrowClick.bind(this))
                    })
                },
                getChildIndex: function(e) {
                    return parseInt(e.dataset.index)
                },
                childNavGoTo: function(e) {
                    this.childNavLinks.forEach(e => {
                        e.blur(), e.classList.remove(t.isActive)
                    });
                    var a = this.childNavLinks[e];
                    if (a.classList.add(t.isActive), !!this.args.childNavScroller)
                        if (this.args.childVertical) {
                            var i = a.offsetTop;
                            this.args.childNavScroller.scrollTop = i - 100
                        } else {
                            var o = a.offsetLeft;
                            this.args.childNavScroller.scrollLeft = o - 100
                        }
                },
                arrowClick: function(e) {
                    e.currentTarget.classList.contains("product__thumb-arrow--prev") ? this.slideshow.previous() : this.slideshow.next()
                }
            }), e
        }(), theme.VariantAvailability = function() {
            function e(e) {
                this.type = e.type, this.variantsObject = e.variantsObject, this.currentVariantObject = e.currentVariantObject, this.container = e.container, this.namespace = e.namespace, this.init()
            }
            var t = {
                disabled: "disabled"
            };
            return e.prototype = Object.assign({}, e.prototype, {
                init: function() {
                    this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)), this.setInitialAvailability()
                },
                createAvailableOptionsTree(e, t) {
                    return e.reduce((e, a) => (Object.keys(e).forEach(i => {
                        if (null === a[i]) return;
                        let o = e[i].find(e => e.value === a[i]);
                        "undefined" == typeof o && (o = {
                            value: a[i],
                            soldOut: !0
                        }, e[i].push(o));
                        const n = t.find(({
                                value: e,
                                index: t
                            }) => "option1" === t),
                            r = t.find(({
                                value: e,
                                index: t
                            }) => "option2" === t);
                        switch (i) {
                            case "option1":
                                o.soldOut = !(o.soldOut && a.available) && o.soldOut;
                                break;
                            case "option2":
                                n && a.option1 === n.value && (o.soldOut = !(o.soldOut && a.available) && o.soldOut);
                            case "option3":
                                n && a.option1 === n.value && r && a.option2 === r.value && (o.soldOut = !(o.soldOut && a.available) && o.soldOut);
                        }
                    }), e), {
                        option1: [],
                        option2: [],
                        option3: []
                    })
                },
                setInitialAvailability: function() {
                    this.container.querySelectorAll(".variant-input-wrap").forEach(e => {
                        this.disableVariantGroup(e)
                    });
                    const e = this.currentVariantObject.options.map((e, t) => ({
                            value: e,
                            index: `option${t+1}`
                        })),
                        t = this.createAvailableOptionsTree(this.variantsObject, e, this.currentVariantObject);
                    for (var [a, i] of Object.entries(t)) this.manageOptionState(a, i)
                },
                setAvailability: function(e) {
                    const {
                        value: t,
                        index: a,
                        currentlySelectedValues: i,
                        variant: o
                    } = e.detail, n = this.createAvailableOptionsTree(this.variantsObject, i, o, a, t);
                    for (var [r, s] of Object.entries(n)) this.manageOptionState(r, s, t)
                },
                manageOptionState: function(e, t) {
                    var a = this.container.querySelector(".variant-input-wrap[data-index=\"" + e + "\"]");
                    t.forEach(e => {
                        this.enableVariantOption(a, e)
                    })
                },
                enableVariantOption: function(e, a) {
                    var i = a.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                    if ("dropdown" === this.type) e.querySelector("option[value=\"" + i + "\"]").disabled = !1;
                    else {
                        var o = e.querySelector(".variant-input[data-value=\"" + i + "\"]"),
                            n = o.querySelector("input"),
                            r = o.querySelector("label");
                        n.classList.remove(t.disabled), r.classList.remove(t.disabled), a.soldOut && (n.classList.add(t.disabled), r.classList.add(t.disabled))
                    }
                },
                disableVariantGroup: function(e) {
                    "dropdown" === this.type ? e.querySelectorAll("option").forEach(e => {
                        e.disabled = !0
                    }) : (e.querySelectorAll("input").forEach(e => {
                        e.classList.add(t.disabled)
                    }), e.querySelectorAll("label").forEach(e => {
                        e.classList.add(t.disabled)
                    }))
                }
            }), e
        }(), theme.videoModal = function() {
            function e(e) {
                if (theme.config.youTubeReady) {
                    e.preventDefault(), o(), u.open(e);
                    var t = i(e.currentTarget.getAttribute("href"));
                    r = new theme.YouTube("VideoHolder", {
                        videoId: t,
                        style: "sound",
                        events: {
                            onReady: a
                        }
                    })
                }
            }

            function t(e) {
                o();
                var t = e.currentTarget,
                    a = t.parentNode.querySelector(s.mp4Player),
                    i = a.cloneNode(!0);
                i.classList.remove("hide"), c.append(i), u.open(e), c.querySelector("video").play()
            }

            function a(e) {
                e.target.unMute(), e.target.playVideo()
            }

            function i(e) {
                var t = e.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/);
                return !!(t && 11 == t[7].length) && t[7]
            }

            function o() {
                c.innerHTML = ""
            }

            function n() {
                r && "function" == typeof r.destroy ? r.destroy() : o()
            }
            var r, s = {
                    youtube: "a[href*=\"youtube.com/watch\"], a[href*=\"youtu.be/\"]",
                    mp4Trigger: ".product-video-trigger--mp4",
                    mp4Player: ".product-video-mp4-sound"
                },
                l = document.querySelectorAll(s.youtube),
                d = document.querySelectorAll(s.mp4Trigger);
            if (l.length || d.length) {
                var c = document.getElementById("VideoHolder");
                l.length && theme.LibraryLoader.load("youtubeSdk");
                var u = new theme.Modals("VideoModal", "video-modal", {
                    closeOffContentClick: !0,
                    bodyOpenClass: ["modal-open", "video-modal-open"],
                    solid: !0
                });
                l.forEach(t => {
                    t.addEventListener("click", e)
                }), d.forEach(e => {
                    e.addEventListener("click", t)
                }), document.addEventListener("modalClose.VideoModal", n)
            }
        };
        class a extends HTMLElement {
            constructor() {
                super(), this.el = this, this.inner = this.querySelector("[data-tool-tip-inner]"), this.closeButton = this.querySelector("[data-tool-tip-close]"), this.toolTipContent = this.querySelector("[data-tool-tip-content]"), this.triggers = document.querySelectorAll("[data-tool-tip-trigger]"), document.addEventListener("tooltip:open", t => {
                    this._open(t.detail.context, t.detail.content)
                })
            }
            _open(e, t) {
                this.toolTipContent.innerHTML = t, theme.a11y.trapFocus({
                    container: this.el,
                    namespace: "tooltip_focus"
                }), this.closeButton && this.closeButton.on("click.tooltip-close", () => {
                    this._close()
                }), document.documentElement.on("click.tooltip-outerclick", e => {
                    "true" !== this.el.dataset.toolTipOpen || this.inner.contains(e.target) || this._close()
                }), document.documentElement.on("keydown.tooltip-esc", e => {
                    "Escape" === e.code && this._close()
                }), this.el.dataset.toolTipOpen = !0, this.el.dataset.toolTip = e
            }
            _close() {
                this.toolTipContent.innerHTML = "", this.el.dataset.toolTipOpen = "false", this.el.dataset.toolTip = "", theme.a11y.removeTrapFocus({
                    container: this.el,
                    namespace: "tooltip_focus"
                }), this.closeButton.off("click.tooltip-close"), document.documentElement.off("click.tooltip-outerclick"), document.documentElement.off("keydown.tooltip-esc")
            }
        }
        customElements.define("tool-tip", a);
        class i extends HTMLElement {
            constructor() {
                super(), this.el = this, this.toolTipContent = this.querySelector("[data-tool-tip-content]"), this.init()
            }
            init() {
                const t = new CustomEvent("tooltip:open", {
                    detail: {
                        context: this.dataset.toolTip,
                        content: this.toolTipContent.innerHTML
                    },
                    bubbles: !0
                });
                this.el.addEventListener("click", a => {
                    a.stopPropagation(), this.dispatchEvent(t)
                })
            }
        }
        customElements.define("tool-tip-trigger", i);
        class o extends HTMLElement {
            constructor() {
                super(), this.closeBtn = this.querySelector("[data-close-button]"), this.popupTrigger = this.querySelector("[data-message]"), this.id = this.dataset.sectionId, this.newsletterId = `NewsletterPopup-${this.id}`, this.cookie = Cookies.get(`newsletter-${this.id}`), this.cookieName = `newsletter-${this.id}`, this.secondsBeforeShow = this.dataset.delaySeconds, this.expiry = parseInt(this.dataset.delayDays), this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, "newsletter-popup-modal"), this.init()
            }
            init() {
                document.addEventListener("shopify:block:select", e => {
                    e.detail.sectionId === this.id && this.show(0, !0)
                }), document.addEventListener("shopify:block:deselect", e => {
                    e.detail.sectionId === this.id && this.hide()
                }), document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide()), document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show()), document.addEventListener(`newsletter:openReminder`, () => this.show(0)), this.closeBtn.addEventListener("click", () => {
                    this.hide(), Cookies.set(this.cookieName, "opened", {
                        path: "/",
                        expires: this.expiry
                    })
                }), this.popupTrigger.addEventListener("click", () => {
                    const e = new CustomEvent("reminder:openNewsletter", {
                        bubbles: !0
                    });
                    this.dispatchEvent(e), this.hide()
                })
            }
            show(e = this.secondsBeforeShow, t = !1) {
                const a = "true" === sessionStorage.getItem("reminderAppeared");
                a || setTimeout(() => {
                    this.dataset.enabled = "true", sessionStorage.setItem("reminderAppeared", !0)
                }, 1e3 * e)
            }
            hide() {
                this.dataset.enabled = "false"
            }
        }
        customElements.define("newsletter-reminder", o), theme.announcementBar = function() {
                function e() {
                    (n = document.getElementById("AnnouncementSlider"), !!n) && (o(), 1 === n.dataset.blockCount || ((theme.config.bpSmall || "true" === n.dataset.compact) && t(), document.addEventListener("matchSmall", function() {
                        o(), t()
                    }), document.addEventListener("unmatchSmall", function() {
                        o(), "true" === n.dataset.compact && t()
                    })))
                }

                function t() {
                    r = new theme.Slideshow(n, s)
                }

                function a(e) {
                    var t = n.querySelector("#AnnouncementSlide-" + e),
                        a = parseInt(t.dataset.index);
                    r && "function" == typeof r.pause && (r.goToSlide(a), r.pause())
                }

                function i() {
                    r && "function" == typeof r.play && r.play()
                }

                function o() {
                    r && "function" == typeof r.destroy && r.destroy()
                }
                var n, r, s = {
                    autoPlay: 5e3,
                    avoidReflow: !0,
                    cellAlign: theme.config.rtl ? "right" : "left"
                };
                return {
                    init: e,
                    onBlockSelect: a,
                    onBlockDeselect: i,
                    unload: o
                }
            }(), theme.customerTemplates = function() {
                function e() {
                    var e = document.getElementById("RecoverPasswordForm").classList.toggle("hide"),
                        t = document.getElementById("CustomerLoginForm").classList.toggle("hide")
                }(function() {
                    var t = window.location.hash;
                    "#recover" === t && e()
                })(),
                function() {
                    var t = document.getElementById("RecoverPassword");
                    t && t.addEventListener("click", function(t) {
                        t.preventDefault(), e()
                    });
                    var a = document.getElementById("HideRecoverPasswordLink");
                    a && a.addEventListener("click", function(t) {
                        t.preventDefault(), e()
                    })
                }(),
                function() {
                    var e = document.querySelector(".reset-password-success");
                    e && document.getElementById("ResetSuccess").classList.remove("hide")
                }(),
                function() {
                    var e = document.getElementById("AddressNewForm"),
                        t = document.querySelectorAll(".js-address-form");
                    e && t.length && (setTimeout(function() {
                        document.querySelectorAll(".js-address-country").forEach(e => {
                            var t = e.dataset.countryId,
                                a = e.dataset.provinceId,
                                i = e.dataset.provinceContainerId;
                            new Shopify.CountryProvinceSelector(t, a, {
                                hideElement: i
                            })
                        })
                    }, 1e3), document.querySelectorAll(".address-new-toggle").forEach(t => {
                        t.addEventListener("click", function() {
                            e.classList.toggle("hide")
                        })
                    }), document.querySelectorAll(".address-edit-toggle").forEach(e => {
                        e.addEventListener("click", function(e) {
                            var t = e.currentTarget.dataset.formId;
                            document.getElementById("EditAddress_" + t).classList.toggle("hide")
                        })
                    }), document.querySelectorAll(".address-delete").forEach(e => {
                        e.addEventListener("click", function(e) {
                            var t = e.currentTarget.dataset.formId,
                                a = e.currentTarget.dataset.confirmMessage;
                            confirm(a || "Are you sure you wish to delete this address?") && Shopify && Shopify.postLink("/account/addresses/" + t, {
                                parameters: {
                                    _method: "delete"
                                }
                            })
                        })
                    }))
                }()
            }, theme.CartDrawer = function() {
                function e() {
                    this.form = document.querySelector(t.form), this.drawer = new theme.Drawers("CartDrawer", "cart"), this.init()
                }
                var t = {
                    drawer: "#CartDrawer",
                    form: "#CartDrawerForm"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.cartForm = new theme.CartForm(this.form), this.cartForm.buildCart(), document.addEventListener("ajaxProduct:added", function() {
                            this.cartForm.buildCart(), this.open()
                        }.bind(this)), document.addEventListener("cart:open", this.open.bind(this)), document.addEventListener("cart:close", this.close.bind(this))
                    },
                    open: function() {
                        this.drawer.open()
                    },
                    close: function() {
                        this.drawer.close()
                    }
                }), e
            }(), theme.headerNav = function() {
                function e() {
                    y = document.querySelector(f.wrapper), v = document.querySelector(f.siteHeader), b.stickyEnabled = "true" === v.dataset.sticky, b.stickyEnabled && (b.wrapperOverlayed = y.classList.contains(b.overlayedClass), a()), theme.settings.overlayHeader = "true" === v.dataset.overlay, theme.settings.overlayHeader && Shopify && Shopify.designMode && document.body.classList.contains("template-collection") && !document.querySelector(".collection-hero") && this.disableOverlayHeader(), l(), d(), window.on("load" + b.namespace, g), window.on("resize" + b.namespace, theme.utils.debounce(150, g))
                }

                function t() {
                    y.classList.remove(b.overlayEnabledClass, b.overlayedClass), b.wrapperOverlayed = !1, theme.settings.overlayHeader = !1
                }

                function a() {
                    theme.config.stickyHeader = i(), theme.config.stickyHeader ? (b.forceStopSticky = !1, o()) : b.forceStopSticky = !0
                }

                function i() {
                    var e = 0;
                    return v.querySelectorAll(f.megamenu).forEach(t => {
                        var a = t.offsetHeight;
                        a > e && (e = a)
                    }), !(window.innerHeight < e + 120)
                }

                function o() {
                    b.lastScroll = 0;
                    var e = document.createElement("div");
                    e.id = b.stickyHeaderWrapper, theme.utils.wrap(v, e), n(), window.on("resize" + b.namespace, theme.utils.debounce(50, n)), window.on("scroll" + b.namespace, theme.utils.throttle(20, r)), Shopify && Shopify.designMode && setTimeout(function() {
                        n()
                    }, 250)
                }

                function n() {
                    if (b.stickyEnabled) {
                        var e = v.offsetHeight,
                            t = document.querySelector("#" + b.stickyHeaderWrapper);
                        t.style.height = e + "px"
                    }
                }

                function r() {
                    !b.stickyEnabled || b.forceStopSticky || (requestAnimationFrame(s), b.lastScroll = window.scrollY)
                }

                function s() {
                    if (250 < window.scrollY) {
                        if (b.stickyActive) return;
                        b.stickyActive = !0, v.classList.add(b.stickyClass), b.wrapperOverlayed && y.classList.remove(b.overlayedClass), setTimeout(function() {
                            v.classList.add(b.openTransitionClass)
                        }, 100)
                    } else {
                        if (!b.stickyActive) return;
                        b.stickyActive = !1, v.classList.remove(b.openTransitionClass), v.classList.remove(b.stickyClass), b.wrapperOverlayed && y.classList.add(b.overlayedClass)
                    }
                }

                function l() {
                    function e(e) {
                        r && o(), s && n(), t(e.currentTarget)
                    }

                    function t(e) {
                        var t = e.parentNode;
                        if (t.classList.contains(S.hasDropdownClass) && (t.classList.add(S.dropdownActive), r = !0), !theme.config.isTouch && !l) {
                            var a = theme.config.isTouch ? "touchend" : "click";
                            l = !0, document.documentElement.on(a + b.namespace, function() {
                                i(), document.documentElement.off(a + b.namespace), l = !1
                            }.bind(this))
                        }
                    }

                    function a(e, t) {
                        var a = e.parentNode;
                        (a.classList.contains(S.hasSubDropdownClass) || t) && (a.classList.add(S.dropdownActive), s = !0)
                    }

                    function i() {
                        o(), n()
                    }

                    function o() {
                        document.querySelectorAll(f.navItems).forEach(e => {
                            e.classList.remove(S.dropdownActive)
                        })
                    }

                    function n() {
                        document.querySelectorAll(f.navDropdownLinks).forEach(e => {
                            e.parentNode.classList.remove(S.dropdownActive)
                        })
                    }
                    var r = !1,
                        s = !1,
                        l = !1;
                    theme.config.isTouch && document.querySelectorAll(f.navLinksWithDropdown).forEach(e => {
                        e.on("touchend" + b.namespace, function(e) {
                            var a = e.currentTarget.parentNode;
                            a.classList.contains(S.dropdownActive) ? window.location.replace(e.currentTarget.getAttribute("href")) : (e.preventDefault(), i(), t(e.currentTarget))
                        })
                    }), document.querySelectorAll(f.navLinks).forEach(t => {
                        t.on("focusin" + b.namespace, e), t.on("mouseover" + b.namespace, e), t.on("mouseleave" + b.namespace, i)
                    }), document.querySelectorAll(f.navDropdownLinks).forEach(e => {
                        theme.config.isTouch && e.on("touchend" + b.namespace, function(e) {
                            var t = e.currentTarget.parentNode;
                            t.classList.contains(S.hasSubDropdownClass) ? t.classList.contains(S.dropdownActive) ? window.location.replace(e.currentTarget.getAttribute("href")) : (e.preventDefault(), n(), a(e.currentTarget)) : window.location.replace(e.currentTarget.getAttribute("href"))
                        }), e.on("focusin" + b.namespace, function(e) {
                            n(), a(e.currentTarget, !0)
                        })
                    }), theme.config.isTouch && (document.body.on("touchend" + b.namespace, function() {
                        i()
                    }), v.querySelectorAll(f.megamenu).forEach(e => {
                        e.on("touchend" + b.namespace, function(e) {
                            e.stopImmediatePropagation()
                        })
                    }))
                }

                function d() {
                    document.querySelectorAll(f.searchBtn).forEach(e => {
                        e.addEventListener("click", c)
                    }), document.querySelector(f.closeSearch).addEventListener("click", u)
                }

                function c(e) {
                    e.preventDefault(), e.stopImmediatePropagation();
                    var t = document.querySelector(f.searchContainer);
                    theme.utils.prepareTransition(t, function() {
                        t.classList.add("is-active")
                    }.bind(this)), document.documentElement.classList.add("js-drawer-open", "js-drawer-open--search"), setTimeout(function() {
                        theme.a11y.trapFocus({
                            container: t,
                            namespace: "header_search",
                            elementToFocus: t.querySelector(".site-header__search-input")
                        })
                    }, 100), theme.config.bpSmall && b.stickyEnabled && 300 > b.lastScroll && window.scrollTo(0, 0), theme.a11y.lockMobileScrolling(b.namespace), p()
                }

                function u(e) {
                    if (e)
                        for (var t = e.path || e.composedPath && e.composedPath(), a = 0; a < t.length; a++)
                            if (t[a].classList) {
                                if (t[a].classList.contains("site-header__search-btn")) break;
                                if (t[a].classList.contains("site-header__search-container")) return
                            } document.activeElement.blur(), document.documentElement.classList.add("js-drawer-closing"), document.documentElement.classList.remove("js-drawer-open", "js-drawer-open--search"), window.setTimeout(function() {
                        document.documentElement.classList.remove("js-drawer-closing")
                    }.bind(this), 500);
                    var o = document.querySelector(f.searchContainer);
                    theme.utils.prepareTransition(o, function() {
                        o.classList.remove("is-active")
                    }.bind(this)), theme.a11y.removeTrapFocus({
                        container: o,
                        namespace: "header_search"
                    }), theme.a11y.unlockMobileScrolling(b.namespace), m()
                }

                function p() {
                    window.on("keyup" + b.namespace, function(e) {
                        27 === e.keyCode && u()
                    }.bind(this)), document.documentElement.on("click" + b.namespace, function(e) {
                        u(e)
                    }.bind(this))
                }

                function m() {
                    window.off("keyup" + b.namespace), document.documentElement.off("click" + b.namespace)
                }

                function g() {
                    document.querySelectorAll(f.logo).forEach(e => {
                        var t = e.clientWidth,
                            a = e.closest(".header-item").clientWidth;
                        t > a ? e.style.maxWidth = a : e.removeAttribute("style")
                    })
                }
                var y, v, f = {
                        wrapper: "#HeaderWrapper",
                        siteHeader: "#SiteHeader",
                        searchBtn: ".js-search-header",
                        closeSearch: "#SearchClose",
                        searchContainer: ".site-header__search-container",
                        logo: "#LogoContainer img",
                        megamenu: ".megamenu",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level"
                    },
                    S = {
                        hasDropdownClass: "site-nav--has-dropdown",
                        hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
                        dropdownActive: "is-focused"
                    },
                    b = {
                        namespace: ".siteNav",
                        wrapperOverlayed: !1,
                        overlayedClass: "is-light",
                        overlayEnabledClass: "header-wrapper--sticky",
                        stickyEnabled: !1,
                        stickyActive: !1,
                        stickyClass: "site-header--stuck",
                        stickyHeaderWrapper: "StickyHeaderWrap",
                        openTransitionClass: "site-header--opening",
                        lastScroll: 0
                    };
                return {
                    init: e,
                    disableOverlayHeader: t
                }
            }(), window.onpageshow = function(e) {
                e && e.persisted && (document.body.classList.remove("unloading"), document.querySelectorAll(".cart__checkout").forEach(e => {
                    e.classList.remove("btn--loading")
                }))
            }, theme.predictiveSearch = function() {
                function e() {
                    v.wrapper.classList.add("hide"), v.results.innerHTML = "", clearTimeout(m)
                }

                function t() {
                    v.form.submit()
                }

                function a(e) {
                    e.preventDefault ? e.preventDefault() : e.returnValue = !1;
                    var t = {},
                        a = new FormData(e.target);
                    for (var i of a.keys()) t[i] = a.get(i);
                    t.q && (t.q += "*");
                    var o = p(t);
                    return window.location.href = `${theme.routes.search}?${o}`, !1
                }

                function i(e) {
                    e.keyCode === S.up_arrow || e.keyCode === S.down_arrow || e.keyCode === S.tab || o()
                }

                function o() {
                    var t = v.input.value;
                    if ("" === t) return void e();
                    var a = u(t);
                    clearTimeout(m), m = setTimeout(function() {
                        n(a)
                    }.bind(this), 500)
                }

                function n(t) {
                    if (!y && g !== t) {
                        g = t, y = !0;
                        var a = {
                                q: t,
                                "resources[type]": theme.settings.predictiveSearchType,
                                "resources[limit]": 4,
                                "resources[options][unavailable_products]": "last",
                                "resources[options][fields]": "title,product_type,variants.title,vendor"
                            },
                            i = p(a);
                        fetch("/search/suggest.json?" + i).then(e => e.json()).then(t => {
                            y = !1;
                            var a = {},
                                o = 0;
                            v.wrapper.classList.remove("hide");
                            var n = Object.entries(t.resources.results);
                            if (Object.keys(n).forEach(function(e) {
                                    var t = n[e],
                                        i = t[0],
                                        c = t[1];
                                    o += c.length, "products" === i ? a[i] = r(c) : "collections" === i ? a[i] = s(c) : "pages" === i ? a[i] = l(c) : "articles" === i ? a[i] = d(c) : void 0
                                }), 0 === o) return void e();
                            var u = c(a);
                            v.results.innerHTML = "", v.results.innerHTML = u
                        })
                    }
                }

                function r(e) {
                    var t = "",
                        a = [];
                    if (e.forEach(e => {
                            var t = {
                                title: e.title,
                                url: e.url,
                                image_responsive_url: theme.Images.lazyloadImagePath(e.image),
                                image_aspect_ratio: e.featured_image.aspect_ratio
                            };
                            a.push(t)
                        }), a.length) {
                        var i = theme.buildProductGridItem(a, "small--one-half medium-up--one-quarter", 4, f.imageSize);
                        t = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${i}
            </div>
          </div>
        `
                    }
                    return t
                }

                function s(e) {
                    var t = "";
                    if (e.length) {
                        var a = theme.buildCollectionItem(e);
                        t = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${a}
            </ul>
          </div>
        `
                    }
                    return t
                }

                function l(e) {
                    var t = "";
                    if (e.length) {
                        var a = theme.buildPageItem(e);
                        t = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${a}
            </ul>
          </div>
        `
                    }
                    return t
                }

                function d(e) {
                    var t = "";
                    if (e.forEach(e => {
                            e.image && (e.image = theme.Images.getSizedImageUrl(e.image, "200x200_crop_center"))
                        }), e.length) {
                        var a = theme.buildArticleItem(e, f.imageSize);
                        t = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${a}
            </div>
          </div>
        `
                    }
                    return t
                }

                function c(e) {
                    var t = "";
                    return e.products && "" !== e.products && (t += e.products), e.collections && "" !== e.collections && (t += e.collections), e.pages && "" !== e.pages && (t += e.pages), e.articles && "" !== e.articles && (t += e.articles), t
                }

                function u(e) {
                    return "string" == typeof e ? e.trim().replace(/\ /g, "-").toLowerCase() : null
                }

                function p(e) {
                    return Object.keys(e).map(function(t) {
                        return t + "=" + encodeURIComponent(e[t])
                    }).join("&")
                }
                var m, g = "",
                    y = !1,
                    h = {
                        form: "#HeaderSearchForm",
                        input: "input[type=\"search\"]",
                        wrapper: "#PredictiveWrapper",
                        resultDiv: "#PredictiveResults",
                        searchButton: "[data-predictive-search-button]"
                    },
                    v = {},
                    f = {
                        imageSize: "square"
                    },
                    S = {
                        up_arrow: 38,
                        down_arrow: 40,
                        tab: 9
                    };
                return {
                    init: function() {
                        if (document.getElementById("shopify-features")) {
                            var e = JSON.parse(document.getElementById("shopify-features").innerHTML);
                            if (!e.predictiveSearch) return
                        }
                        v.wrapper = document.querySelector(h.wrapper), v.wrapper && (f.imageSize = v.wrapper.dataset.imageSize, v.form = document.querySelector(h.form), v.form.setAttribute("autocomplete", "off"), v.form.on("submit.predictive", a), v.input = v.form.querySelector(h.input), v.input.on("keyup.predictive", i), v.submit = v.wrapper.querySelector(h.searchButton), v.submit.on("click.predictive", t), v.results = document.querySelector(h.resultDiv))
                    }
                }
            }(), theme.buildProductGridItem = function(e, t, a, i) {
                var o = "";
                return e.forEach(e => {
                    var n = theme.buildProductImage(e, i),
                        r = `
        <div class="grid__item grid-product ${t} aos-animate" data-aos="row-of-${a}">
          <div class="grid-product__content">
            <a href="${e.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${n}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${e.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;
                    o += r
                }), o
            }, theme.buildProductImage = function(e, t) {
                var a = t ? t : theme.settings.productImageSize,
                    i = "";
                if ("natural" === a) i = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${e.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${e.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${e.image_aspect_ratio}"
            data-sizes="auto"
            alt="${e.title}">
        </div>`;
                else {
                    var o = "lazyload";
                    theme.settings.productImageCover || (o += " grid__image-contain"), i = `
        <div class="grid__image-ratio grid__image-ratio--${a}">
          <img class="${o}"
              data-src="${e.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${e.aspect_ratio}"
              data-sizes="auto"
              alt="${e.title}">
        </div>
      `
                }
                return i
            }, theme.buildCollectionItem = function(e) {
                var t = "";
                return e.forEach(e => {
                    var a = `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
                    t += a
                }), t
            }, theme.buildPageItem = function(e) {
                var t = "";
                return e.forEach(e => {
                    var a = `
        <li>
          <a href="${e.url}">
            ${e.title}
          </a>
        </li>
      `;
                    t += a
                }), t
            }, theme.buildArticleItem = function(e, t) {
                var a = "";
                return e.forEach(e => {
                    var i = theme.buildPredictiveImage(e),
                        o = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${e.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${t}">
                <div class="predictive__image-wrap">
                  ${i}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${e.title}
            </div>
          </a>
        </div>
      `;
                    a += o
                }), a
            }, theme.buildPredictiveImage = function(e) {
                var t = "";
                return e.image && (t = `<img class="lazyload"
            data-src="${e.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`), t
            }, theme.Maps = function() {
                function e(e) {
                    this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.namespace = ".map-" + this.sectionId, this.map = e.querySelector(s.map), this.key = this.map.dataset.apiKey, r = {
                        addressNoResults: theme.strings.addressNoResults,
                        addressQueryLimit: theme.strings.addressQueryLimit,
                        addressError: theme.strings.addressError,
                        authError: theme.strings.authError
                    }, this.key && theme.initWhenVisible({
                        element: this.container,
                        callback: this.prepMapApi.bind(this),
                        threshold: 20
                    })
                }

                function t() {
                    n.forEach(e => {
                        e.createMap()
                    })
                }

                function a(e) {
                    var t = new google.maps.Geocoder;
                    if (e) {
                        var a = e.dataset.addressSetting,
                            i = new Promise((e, i) => {
                                t.geocode({
                                    address: a
                                }, function(t, a) {
                                    a !== google.maps.GeocoderStatus.OK && i(a), e(t)
                                })
                            });
                        return i
                    }
                }
                var i = {
                        zoom: 14
                    },
                    o = null,
                    n = [],
                    r = {},
                    s = {
                        section: "[data-section-type=\"map\"]",
                        map: "[data-map]",
                        mapOverlay: ".map-section__overlay"
                    };
                return window.gm_authFailure = function() {
                    Shopify.designMode && (document.querySelectorAll(s.section).forEach(e => {
                        e.classList.add("map-section--load-error")
                    }), document.querySelectorAll(s.map).forEach(e => {
                        e.parentNode.removeChild(e)
                    }), window.mapError(theme.strings.authError))
                }, window.mapError = function(e) {
                    var t = document.createElement("div");
                    t.classList.add("map-section__error", "errors", "text-center"), t.innerHTML = e, document.querySelectorAll(s.mapOverlay).forEach(e => {
                        e.parentNode.prepend(t)
                    }), document.querySelectorAll(".map-section__link").forEach(e => {
                        e.classList.add("hide")
                    })
                }, e.prototype = Object.assign({}, e.prototype, {
                    prepMapApi: function() {
                        if ("loaded" === o) this.createMap();
                        else if (n.push(this), "loading" !== o && (o = "loading", "undefined" == typeof window.google || "undefined" == typeof window.google.maps)) {
                            var e = document.createElement("script");
                            e.onload = function() {
                                o = "loaded", t()
                            }, e.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key, document.head.appendChild(e)
                        }
                    },
                    createMap: function() {
                        var e = this.map;
                        return a(e).then(function(t) {
                            var a = {
                                    zoom: i.zoom,
                                    backgroundColor: "none",
                                    center: t[0].geometry.location,
                                    draggable: !1,
                                    clickableIcons: !1,
                                    scrollwheel: !1,
                                    disableDoubleClickZoom: !0,
                                    disableDefaultUI: !0
                                },
                                o = this.map = new google.maps.Map(e, a),
                                n = this.center = o.getCenter(),
                                r = new google.maps.Marker({
                                    map: o,
                                    position: o.getCenter()
                                });
                            google.maps.event.addDomListener(window, "resize", theme.utils.debounce(250, function() {
                                google.maps.event.trigger(o, "resize"), o.setCenter(n), e.removeAttribute("style")
                            })), Shopify.designMode && window.AOS && AOS.refreshHard()
                        }.bind(this)).catch(function(e) {
                            var t;
                            t = "ZERO_RESULTS" === e ? r.addressNoResults : "OVER_QUERY_LIMIT" === e ? r.addressQueryLimit : "REQUEST_DENIED" === e ? r.authError : r.addressError, Shopify.designMode && window.mapError(t)
                        })
                    },
                    onUnload: function() {
                        0 === this.map.length || google && google.maps && google.maps.event && google.maps.event.clearListeners(this.map, "resize")
                    }
                }), e
            }(), theme.NewsletterPopup = function() {
                function e(e) {
                    this.container = e;
                    var t = this.container.getAttribute("data-section-id");
                    if ((this.cookieName = "newsletter-" + t, this.cookie = Cookies.get(this.cookieName), !!e) && "/challenge" !== window.location.pathname && "/password" !== window.location.pathname) {
                        this.data = {
                            secondsBeforeShow: e.dataset.delaySeconds,
                            daysBeforeReappear: e.dataset.delayDays,
                            hasReminder: e.dataset.hasReminder,
                            testMode: e.dataset.testMode,
                            isEnabled: e.dataset.enabled
                        }, this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal");
                        var a = e.querySelector(".popup-cta a");
                        return a && a.addEventListener("click", function() {
                            this.closePopup(!0)
                        }.bind(this)), (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(), e.querySelector(".note--success") ? void this.closePopup(!0) : void(document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)), !this.cookie && "true" === this.data.isEnabled && this.initPopupDelay(), document.addEventListener("reminder:openNewsletter", () => {
                            this.modal.open()
                        }))
                    }
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    initPopupDelay: function() {
                        "true" === this.data.testMode || setTimeout(function() {
                            const e = "true" === sessionStorage.getItem("newsletterAppeared");
                            if (e) {
                                const e = new CustomEvent("newsletter:openReminder", {
                                    bubbles: !0
                                });
                                this.container.dispatchEvent(e)
                            } else this.modal.open(), sessionStorage.setItem("newsletterAppeared", !0)
                        }.bind(this), 1e3 * this.data.secondsBeforeShow)
                    },
                    closePopup: function(e) {
                        if ("true" === this.data.testMode) return void Cookies.remove(this.cookieName, {
                            path: "/"
                        });
                        var t = e ? 200 : this.data.daysBeforeReappear,
                            a = "true" === this.data.hasReminder,
                            i = "true" === sessionStorage.getItem("reminderAppeared");
                        a && i ? Cookies.set(this.cookieName, "opened", {
                            path: "/",
                            expires: t
                        }) : !a && Cookies.set(this.cookieName, "opened", {
                            path: "/",
                            expires: t
                        })
                    },
                    onLoad: function() {
                        this.modal.open()
                    },
                    onSelect: function() {
                        this.modal.open()
                    },
                    onDeselect: function() {
                        this.modal.close()
                    },
                    onBlockSelect: function() {
                        this.modal.close()
                    },
                    onBlockDeselect: function() {
                        this.modal.open()
                    }
                }), e
            }(), theme.PasswordHeader = function() {
                function e() {
                    this.init()
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        if (document.querySelector("#LoginModal")) {
                            var e = new theme.Modals("LoginModal", "login-modal", {
                                focusIdOnOpen: "password",
                                solid: !0
                            });
                            document.querySelectorAll(".errors").length && e.open()
                        }
                    }
                }), e
            }(), theme.Photoswipe = function() {
                function e(e, t) {
                    this.container = e, this.sectionId = t, this.namespace = ".photoswipe-" + this.sectionId, this.gallery, this.images, this.items, this.inSlideshow = !1, e && "false" !== e.dataset.zoom && this.init()
                }
                var t = {
                    trigger: ".js-photoswipe__zoom",
                    images: ".photoswipe__image",
                    slideshowTrack: ".flickity-viewport ",
                    activeImage: ".is-selected"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.container.querySelectorAll(t.trigger).forEach(e => {
                            e.on("click" + this.namespace, this.triggerClick.bind(this))
                        })
                    },
                    triggerClick: function(e) {
                        this.inSlideshow = !!(this.container.dataset && "true" === this.container.dataset.hasSlideshow), this.items = this.getImageData();
                        var a = this.inSlideshow ? this.container.querySelector(t.activeImage) : e.currentTarget,
                            i = this.inSlideshow ? this.getChildIndex(a) : a.dataset.index;
                        this.initGallery(this.items, i)
                    },
                    getChildIndex: function(e) {
                        for (var t = 0; null != (e = e.previousSibling);) t++;
                        return t + 1
                    },
                    getImageData: function() {
                        this.images = this.inSlideshow ? this.container.querySelectorAll(t.slideshowTrack + t.images) : this.container.querySelectorAll(t.images);
                        var e = [];
                        return this.images.forEach(t => {
                            var a = {
                                msrc: t.currentSrc || t.src,
                                src: t.getAttribute("data-photoswipe-src"),
                                w: t.getAttribute("data-photoswipe-width"),
                                h: t.getAttribute("data-photoswipe-height"),
                                el: t,
                                initialZoomLevel: .5
                            };
                            e.push(a)
                        }), e
                    },
                    initGallery: function(e, t) {
                        var a = document.querySelectorAll(".pswp")[0];
                        this.gallery = new PhotoSwipe(a, PhotoSwipeUI_Default, e, {
                            allowPanToNext: !1,
                            captionEl: !1,
                            closeOnScroll: !1,
                            counterEl: !1,
                            history: !1,
                            index: t - 1,
                            pinchToClose: !1,
                            preloaderEl: !1,
                            scaleMode: "zoom",
                            shareEl: !1,
                            tapToToggleControls: !1,
                            getThumbBoundsFn: function(t) {
                                var a = window.pageYOffset || document.documentElement.scrollTop,
                                    i = e[t].el,
                                    o = i.getBoundingClientRect();
                                return {
                                    x: o.left,
                                    y: o.top + a,
                                    w: o.width
                                }
                            }
                        }), this.gallery.listen("afterChange", this.afterChange.bind(this)), this.gallery.init(), this.preventiOS15Scrolling()
                    },
                    afterChange: function() {
                        var e = this.gallery.getCurrentIndex();
                        this.container.dispatchEvent(new CustomEvent("photoswipe:afterChange", {
                            detail: {
                                index: e
                            }
                        }))
                    },
                    syncHeight: function() {
                        document.documentElement.style.setProperty("--window-inner-height", `${window.innerHeight}px`)
                    },
                    preventiOS15Scrolling: function() {
                        let e;
                        /iPhone|iPad|iPod/i.test(window.navigator.userAgent) && (this.syncHeight(), e = window.scrollY, document.documentElement.classList.add("pswp-open-in-ios"), window.addEventListener("resize", this.syncHeight), this.gallery.listen("destroy", () => {
                            document.documentElement.classList.remove("pswp-open-in-ios"), window.scrollTo(0, e)
                        }))
                    }
                }), e
            }(), theme.Recommendations = function() {
                function e(e) {
                    this.container = e, this.sectionId = e.getAttribute("data-section-id"), this.url = e.dataset.url, t.recommendations = "Recommendations-" + this.sectionId, theme.initWhenVisible({
                        element: e,
                        callback: this.init.bind(this),
                        threshold: 500
                    })
                }
                var t = {
                    placeholder: ".product-recommendations-placeholder",
                    sectionClass: " .product-recommendations",
                    productResults: ".grid-product"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        var e = document.getElementById(t.recommendations);
                        if (e && "false" !== e.dataset.enable) {
                            var a = this.url;
                            if (Shopify.designMode) {
                                var i = e.querySelector(t.sectionClass);
                                i && (i.innerHTML = "")
                            }
                            fetch(a).then(function(e) {
                                return e.text()
                            }).then(function(a) {
                                var i = new DOMParser,
                                    o = i.parseFromString(a, "text/html"),
                                    n = o.querySelector(t.sectionClass),
                                    r = e.querySelector(t.placeholder);
                                if (r) {
                                    if (r.innerHTML = "", !n) return this.container.classList.add("hide"), void(AOS && AOS.refreshHard());
                                    r.appendChild(n), theme.reinitProductGridItem(e), document.dispatchEvent(new CustomEvent("recommendations:loaded", {
                                        detail: {
                                            section: e
                                        }
                                    }));
                                    var s = n.querySelectorAll(t.productResults);
                                    0 === s.length && this.container.classList.add("hide")
                                }
                            }.bind(this))
                        }
                    }
                }), e
            }(), theme.SlideshowSection = function() {
                function e(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    if (this.slideshow = e.querySelector("#Slideshow-" + t), this.namespace = "." + t, this.initialIndex = 0, !!this.slideshow) {
                        var a = e.parentElement,
                            i = [].indexOf.call(a.parentElement.children, a);
                        0 === i ? this.init() : theme.initWhenVisible({
                            element: this.container,
                            callback: this.init.bind(this)
                        })
                    }
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        var e = this.slideshow.querySelectorAll(".slideshow__slide");
                        if (this.container.hasAttribute("data-immediate-load") ? (this.slideshow.classList.remove("loading", "loading--delayed"), this.slideshow.classList.add("loaded")) : theme.loadImageSection(this.slideshow), 1 < e.length) {
                            var t = {
                                prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                                pageDots: this.slideshow.hasAttribute("data-dots"),
                                fade: !0,
                                setGallerySize: !1,
                                initialIndex: this.initialIndex,
                                autoPlay: "true" === this.slideshow.dataset.autoplay && parseInt(this.slideshow.dataset.speed)
                            };
                            this.flickity = new theme.Slideshow(this.slideshow, t)
                        } else e[0].classList.add("is-selected")
                    },
                    forceReload: function() {
                        this.onUnload(), this.init()
                    },
                    onUnload: function() {
                        this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                    },
                    onDeselect: function() {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                    },
                    onBlockSelect: function(e) {
                        var t = this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId),
                            a = parseInt(t.dataset.index);
                        this.flickity && "function" == typeof this.flickity.pause ? (this.flickity.goToSlide(a), this.flickity.pause()) : (this.initialIndex = a, setTimeout(function() {
                            this.flickity && "function" == typeof this.flickity.pause && this.flickity.pause()
                        }.bind(this), 1e3))
                    },
                    onBlockDeselect: function() {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.args.autoPlay && this.flickity.play()
                    }
                }), e
            }(), theme.StoreAvailability = function() {
                function e(e) {
                    this.container = e, this.baseUrl = e.dataset.baseUrl, this.productTitle = e.dataset.productName
                }
                var t = {
                    drawerOpenBtn: ".js-drawer-open-availability",
                    modalOpenBtn: ".js-modal-open-availability",
                    productTitle: "[data-availability-product-title]"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    updateContent: function(e) {
                        var a = this.baseUrl + "/variants/" + e + "/?section_id=store-availability",
                            i = this;
                        fetch(a).then(function(e) {
                            return e.text()
                        }).then(function(e) {
                            if ("" === e.trim()) return void(this.container.innerHTML = "");
                            i.container.innerHTML = e, i.container.innerHTML = i.container.firstElementChild.innerHTML, i.container.querySelector(t.drawerOpenBtn) && (i.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability")), i.container.querySelector(t.modalOpenBtn) && (i.modal = new theme.Modals("StoreAvailabilityModal", "availability"));
                            var a = i.container.querySelector(t.productTitle);
                            a && (a.textContent = i.productTitle)
                        })
                    }
                }), e
            }(), theme.VideoSection = function() {
                function e(e) {
                    this.container = e, this.sectionId = e.getAttribute("data-section-id"), this.namespace = ".video-" + this.sectionId, this.videoObject, theme.initWhenVisible({
                        element: this.container,
                        callback: this.init.bind(this),
                        threshold: 500
                    })
                }
                var t = {
                    videoParent: ".video-parent-section"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        var e = this.container.querySelector(".video-div");
                        if (e) {
                            var t = e.dataset.type;
                            switch (t) {
                                case "youtube":
                                    var a = e.dataset.videoId;
                                    this.initYoutubeVideo(a);
                                    break;
                                case "vimeo":
                                    var a = e.dataset.videoId;
                                    this.initVimeoVideo(a);
                                    break;
                                case "mp4":
                                    this.initMp4Video();
                            }
                        }
                    },
                    initYoutubeVideo: function(e) {
                        this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
                            videoId: e,
                            videoParent: t.videoParent
                        })
                    },
                    initVimeoVideo: function(e) {
                        this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, e, {
                            videoParent: t.videoParent
                        })
                    },
                    initMp4Video: function() {
                        var e = "Mp4Video-" + this.sectionId,
                            a = document.getElementById(e),
                            i = a.closest(t.videoParent);
                        if (a) {
                            i.classList.add("loaded");
                            var o = document.querySelector("#" + e).play();
                            void 0 !== o && o.then(function() {}).catch(function() {
                                a.setAttribute("controls", ""), i.classList.add("video-interactable")
                            })
                        }
                    },
                    onUnload: function(e) {
                        e.target.id.replace("shopify-section-", "");
                        this.videoObject && "function" == typeof this.videoObject.destroy && this.videoObject.destroy()
                    }
                }), e
            }(), theme.Blog = function() {
                function e() {
                    this.tagFilters()
                }
                return e.prototype = Object.assign({}, e.prototype, {
                    tagFilters: function() {
                        var e = document.getElementById("BlogTagFilter");
                        e && e.addEventListener("change", function() {
                            location.href = e.value
                        })
                    }
                }), e
            }(), theme.CollectionHeader = function() {
                function e(e) {
                    this.namespace = ".collection-header";
                    var a = e.querySelector(".collection-hero");
                    a ? (t && this.checkIfNeedReload(), theme.loadImageSection(a)) : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(), t = !0
                }
                var t = !1;
                return e.prototype = Object.assign({}, e.prototype, {
                    checkIfNeedReload: function() {
                        if (Shopify.designMode && theme.settings.overlayHeader) {
                            var e = document.querySelector(".header-wrapper");
                            e.classList.contains("header-wrapper--overlay") || location.reload()
                        }
                    }
                }), e
            }(), theme.CollectionSidebar = function() {
                function e(e) {
                    this.container = e.querySelector(a.sidebar)
                }
                var t = !1,
                    a = {
                        sidebar: "#CollectionSidebar"
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.container && (this.onUnload(), t = "drawer" === this.container.dataset.style, theme.FilterDrawer = new theme.Drawers("FilterDrawer", "collection-filters", !0))
                    },
                    forceReload: function() {
                        this.init()
                    },
                    onSelect: function() {
                        if (theme.FilterDrawer) {
                            if (!t) return void theme.FilterDrawer.close();
                            (t || theme.config.bpSmall) && theme.FilterDrawer.open()
                        }
                    },
                    onDeselect: function() {
                        theme.FilterDrawer && theme.FilterDrawer.close()
                    },
                    onUnload: function() {
                        theme.FilterDrawer && theme.FilterDrawer.close()
                    }
                }), e
            }(), theme.Collection = function() {
                function e(e) {
                    this.container = e, this.sectionId = e.getAttribute("data-section-id"), this.namespace = ".collection-" + this.sectionId, this.sidebar = new theme.CollectionSidebar(e), this.ajaxRenderer = new theme.AjaxRenderer({
                        sections: [{
                            sectionId: this.sectionId,
                            nodeId: "CollectionAjaxContent"
                        }],
                        onReplace: this.onReplaceAjaxContent.bind(this)
                    }), this.init()
                }
                var t = !1,
                    a = {
                        sortSelect: "#SortBy",
                        colorSwatchImage: ".grid-product__color-image",
                        colorSwatch: ".color-swatch--with-image",
                        collectionGrid: ".collection-grid__wrapper",
                        trigger: ".collapsible-trigger",
                        sidebar: "#CollectionSidebar",
                        filterSidebar: ".collapsible-content--sidebar",
                        activeTagList: ".tag-list--active-tags",
                        tags: ".tag-list input",
                        activeTags: ".tag-list a",
                        tagsForm: ".filter-form",
                        filters: ".collection-filter",
                        priceRange: ".price-range"
                    },
                    i = {
                        activeTag: "tag--active",
                        removeTagParent: "tag--remove",
                        filterSidebar: "collapsible-content--sidebar",
                        isOpen: "is-open"
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.initSort(), this.colorSwatchHovering(), this.initFilters(), this.initPriceRange(), this.sidebar.init()
                    },
                    initSort: function() {
                        this.sortSelect = document.querySelector(a.sortSelect), this.sortSelect && (this.defaultSort = this.getDefaultSortValue(), this.sortSelect.on("change" + this.namespace, this.onSortChange.bind(this)))
                    },
                    getSortValue: function() {
                        return this.sortSelect.value || this.defaultSort
                    },
                    getDefaultSortValue: function() {
                        return this.sortSelect.getAttribute("data-default-sortby")
                    },
                    onSortChange: function() {
                        this.queryParams = new URLSearchParams(window.location.search), this.queryParams.set("sort_by", this.getSortValue()), this.queryParams.delete("page"), window.location.search = this.queryParams.toString()
                    },
                    colorSwatchHovering: function() {
                        var e = this.container.querySelectorAll(a.colorSwatchImage);
                        e.length && this.container.querySelectorAll(a.colorSwatch).forEach(e => {
                            e.addEventListener("mouseenter", function() {
                                var t = e.dataset.variantId,
                                    a = e.dataset.variantImage,
                                    i = document.querySelector(".grid-product__color-image--" + t);
                                i.style.backgroundImage = "url(" + a + ")", i.classList.add("is-active")
                            }), e.addEventListener("mouseleave", function() {
                                var t = e.dataset.variantId;
                                document.querySelector(".grid-product__color-image--" + t).classList.remove("is-active")
                            })
                        })
                    },
                    initFilters: function() {
                        var e = document.querySelectorAll(a.tags);
                        e.length && (this.bindBackButton(), theme.config.stickyHeader && (this.setFilterStickyPosition(), window.on("resize", theme.utils.debounce(500, this.setFilterStickyPosition))), document.querySelectorAll(a.activeTags).forEach(e => {
                            e.addEventListener("click", this.tagClick.bind(this))
                        }), document.querySelectorAll(a.tagsForm).forEach(e => {
                            e.addEventListener("input", this.onFormSubmit.bind(this))
                        }))
                    },
                    initPriceRange: function() {
                        const e = document.querySelectorAll(a.priceRange);
                        e.forEach(e => new theme.PriceRange(e, {
                            onChange: this.renderFromFormData.bind(this)
                        }))
                    },
                    tagClick: function(e) {
                        var a = e.currentTarget;
                        if (theme.FilterDrawer && theme.FilterDrawer.close(), a.classList.contains("no-ajax")) return;
                        if (e.preventDefault(), t) return;
                        t = !0;
                        const i = a.parentNode,
                            o = new URL(a.href);
                        this.renderActiveTag(i, a), this.updateScroll(!0), this.startLoading(), this.renderCollectionPage(o.searchParams)
                    },
                    onFormSubmit: function(e) {
                        var a = e.target;
                        if (theme.FilterDrawer && theme.FilterDrawer.close(), a.classList.contains("no-ajax")) return;
                        if (e.preventDefault(), t) return;
                        t = !0;
                        const i = a.closest("li"),
                            o = a.closest("form"),
                            n = new FormData(o);
                        this.renderActiveTag(i, a), this.updateScroll(!0), this.startLoading(), this.renderFromFormData(n)
                    },
                    fetchOpenCollasibleFilters: function() {
                        return Array.from(document.querySelectorAll(`${a.sidebar} ${a.trigger}.${i.isOpen}`)).map(e => e.dataset.collapsibleId)
                    },
                    renderActiveTag: function(e, t) {
                        const o = e.querySelector(".tag__text");
                        e.classList.contains(i.activeTag) ? e.classList.remove(i.activeTag) : (e.classList.add(i.activeTag), t.closest("li").classList.contains(i.removeTagParent) ? e.remove() : document.querySelectorAll(a.activeTagList).forEach(e => {
                            const t = document.createElement("li"),
                                a = document.createElement("a");
                            t.classList.add("tag", "tag--remove"), a.classList.add("btn", "btn--small"), a.innerText = o.innerText, t.appendChild(a), e.appendChild(t)
                        }))
                    },
                    renderFromFormData: function(e) {
                        const t = new URLSearchParams(e);
                        this.renderCollectionPage(t)
                    },
                    onReplaceAjaxContent: function(e, t) {
                        const a = this.fetchOpenCollasibleFilters();
                        a.forEach(t => {
                            e.querySelectorAll(`[data-collapsible-id=${t}]`).forEach(this.openCollapsible)
                        });
                        var i = e.getElementById(t.nodeId);
                        i && (document.getElementById(t.nodeId).innerHTML = i.innerHTML)
                    },
                    openCollapsible: function(e) {
                        e.classList.contains(i.filterSidebar) && (e.style.height = "auto"), e.classList.add(i.isOpen)
                    },
                    renderCollectionPage: function(e, a = !0) {
                        this.ajaxRenderer.renderPage(window.location.pathname, e, a).then(() => {
                            theme.sections.reinit("collection-grid"), this.updateScroll(!1), this.initPriceRange(), theme.reinitProductGridItem(), document.dispatchEvent(new CustomEvent("collection:reloaded")), t = !1
                        })
                    },
                    bindBackButton: function() {
                        window.off("popstate" + this.namespace), window.on("popstate" + this.namespace, function(e) {
                            if (e) {
                                const e = new URL(window.location.href);
                                this.renderCollectionPage(e.searchParams, !1)
                            }
                        }.bind(this))
                    },
                    updateScroll: function(e) {
                        var t = document.querySelector("[data-scroll-to]"),
                            a = t && t.offsetTop;
                        if (theme.config.bpSmall || (a -= 15), theme.config.stickyHeader) {
                            var i = document.querySelector(".site-header").offsetHeight;
                            a -= i
                        }
                        e ? window.scrollTo({
                            top: a,
                            behavior: "smooth"
                        }) : window.scrollTo({
                            top: a
                        })
                    },
                    setFilterStickyPosition: function() {
                        var e = document.querySelector(".site-header").offsetHeight;
                        document.querySelector(a.filters).style.top = e + 10 + "px";
                        var t = document.querySelector(".grid__item--sidebar");
                        t && (t.style.top = e + 10 + "px")
                    },
                    forceReload: function() {
                        this.init()
                    },
                    startLoading: function() {
                        document.querySelector(a.collectionGrid).classList.add("unload")
                    }
                }), e
            }(), theme.FooterSection = function() {
                function e(e) {
                    this.container = e, this.localeDisclosure = null, this.currencyDisclosure = null, this.init()
                }
                var t = {
                    locale: "[data-disclosure-locale]",
                    currency: "[data-disclosure-currency]"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        var e = this.container.querySelector(t.locale),
                            a = this.container.querySelector(t.currency);
                        e && (this.localeDisclosure = new theme.Disclosure(e)), a && (this.currencyDisclosure = new theme.Disclosure(a));
                        var i = document.querySelector(".footer__newsletter-input");
                        i && i.addEventListener("keyup", function() {
                            i.classList.add("footer__newsletter-input--active")
                        }), theme.collapsibles.init(this.container)
                    },
                    onUnload: function() {
                        this.localeDisclosure && this.localeDisclosure.destroy(), this.currencyDisclosure && this.currencyDisclosure.destroy()
                    }
                }), e
            }(), theme.HeaderSection = function() {
                function e(e) {
                    this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.init()
                }
                var t = {
                    locale: "[data-disclosure-locale]",
                    currency: "[data-disclosure-currency]"
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        Shopify && Shopify.designMode && (theme.sections.reinit("slideshow-section"), setTimeout(function() {
                            window.dispatchEvent(new Event("resize"))
                        }, 500)), this.initDrawers(), this.initDisclosures(), theme.headerNav.init(), theme.announcementBar.init()
                    },
                    initDisclosures: function() {
                        var e = this.container.querySelector(t.locale),
                            a = this.container.querySelector(t.currency);
                        e && (this.localeDisclosure = new theme.Disclosure(e)), a && (this.currencyDisclosure = new theme.Disclosure(a))
                    },
                    initDrawers: function() {
                        theme.NavDrawer = new theme.Drawers("NavDrawer", "nav"), "drawer" !== theme.settings.cartType || document.body.classList.contains("template-cart") || new theme.CartDrawer, theme.collapsibles.init(document.getElementById("NavDrawer"))
                    },
                    onBlockSelect: function(e) {
                        theme.announcementBar.onBlockSelect(e.detail.blockId)
                    },
                    onBlockDeselect: function() {
                        theme.announcementBar.onBlockDeselect()
                    },
                    onUnload: function() {
                        theme.NavDrawer.close(), theme.announcementBar.unload(), this.localeDisclosure && this.localeDisclosure.destroy(), this.currencyDisclosure && this.currencyDisclosure.destroy()
                    }
                }), e
            }(), theme.Product = function() {
                function e(e) {
                    this.container = e;
                    var t = this.sectionId = e.getAttribute("data-section-id"),
                        a = this.productId = e.getAttribute("data-product-id");
                    this.inModal = "true" === e.dataset.modal, this.modal, this.settings = {
                        enableHistoryState: e.dataset.history || !1,
                        namespace: ".product-" + t,
                        inventory: !1,
                        inventoryThreshold: 10,
                        modalInit: !1,
                        hasImages: !0,
                        imageSetName: null,
                        imageSetIndex: null,
                        currentImageSet: null,
                        imageSize: "620x",
                        currentSlideIndex: 0,
                        videoLooping: e.dataset.videoLooping
                    }, this.inModal && (this.settings.enableHistoryState = !1, this.settings.namespace = ".product-" + t + "-modal", this.modal = document.getElementById("QuickShopModal-" + a)), this.selectors = {
                        variantsJson: "[data-variant-json]",
                        currentVariantJson: "[data-current-variant-json]",
                        form: ".product-single__form",
                        media: "[data-product-media-type-model]",
                        closeMedia: ".product-single__close-media",
                        photoThumbs: "[data-product-thumb]",
                        thumbSlider: "[data-product-thumbs]",
                        thumbScroller: ".product__thumbs--scroller",
                        mainSlider: "[data-product-photos]",
                        imageContainer: "[data-product-images]",
                        productImageMain: "[data-product-image-main]",
                        priceWrapper: "[data-product-price-wrap]",
                        price: "[data-product-price]",
                        comparePrice: "[data-compare-price]",
                        savePrice: "[data-save-price]",
                        priceA11y: "[data-a11y-price]",
                        comparePriceA11y: "[data-compare-price-a11y]",
                        unitWrapper: "[data-unit-price-wrapper]",
                        unitPrice: "[data-unit-price]",
                        unitPriceBaseUnit: "[data-unit-base]",
                        sku: "[data-sku]",
                        inventory: "[data-product-inventory]",
                        incomingInventory: "[data-incoming-inventory]",
                        colorLabel: "[data-variant-color-label]",
                        addToCart: "[data-add-to-cart]",
                        addToCartText: "[data-add-to-cart-text]",
                        originalSelectorId: "[data-product-select]",
                        singleOptionSelector: "[data-variant-input]",
                        variantColorSwatch: ".variant__input--color-swatch",
                        availabilityContainer: "[data-store-availability-holder]"
                    }, this.cacheElements(), this.firstProductImage = this.cache.mainSlider.querySelector("img"), this.firstProductImage || (this.settings.hasImages = !1);
                    var i = this.cache.mainSlider.querySelector("[data-set-name]");
                    i && (this.settings.imageSetName = i.dataset.setName), this.init()
                }
                var t = {},
                    a = {
                        onSale: "on-sale",
                        disabled: "disabled",
                        isModal: "is-modal",
                        loading: "loading",
                        loaded: "loaded",
                        hidden: "hide",
                        interactable: "video-interactable",
                        visuallyHide: "visually-invisible"
                    },
                    i = {
                        productVideo: ".product__video",
                        videoParent: ".product__video-wrapper",
                        slide: ".product-main-slide",
                        currentSlide: ".is-selected",
                        startingSlide: ".starting-slide",
                        variantType: ".variant-wrapper",
                        blocks: "[data-product-blocks]",
                        blocksHolder: "[data-blocks-holder]"
                    };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        this.inModal && (this.container.classList.add(a.isModal), document.addEventListener("modalOpen.QuickShopModal-" + this.productId, this.openModalProduct.bind(this)), document.addEventListener("modalClose.QuickShopModal-" + this.productId, this.closeModalProduct.bind(this))), this.inModal || (this.formSetup(), this.productSetup(), this.videoSetup(), this.initProductSlider(), this.customMediaListners(), this.addIdToRecentlyViewed())
                    },
                    cacheElements: function() {
                        this.cache = {
                            form: this.container.querySelector(this.selectors.form),
                            mainSlider: this.container.querySelector(this.selectors.mainSlider),
                            thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
                            thumbScroller: this.container.querySelector(this.selectors.thumbScroller),
                            productImageMain: this.container.querySelector(this.selectors.productImageMain),
                            priceWrapper: this.container.querySelector(this.selectors.priceWrapper),
                            comparePriceA11y: this.container.querySelector(this.selectors.comparePriceA11y),
                            comparePrice: this.container.querySelector(this.selectors.comparePrice),
                            price: this.container.querySelector(this.selectors.price),
                            savePrice: this.container.querySelector(this.selectors.savePrice),
                            priceA11y: this.container.querySelector(this.selectors.priceA11y)
                        }
                    },
                    formSetup: function() {
                        this.initQtySelector(), this.initAjaxProductForm(), this.availabilitySetup(), this.initVariants(), this.settings.imageSetName && this.updateImageSet()
                    },
                    availabilitySetup: function() {
                        var e = this.container.querySelector(this.selectors.availabilityContainer);
                        e && (this.storeAvailability = new theme.StoreAvailability(e))
                    },
                    productSetup: function() {
                        this.setImageSizes(), this.initImageZoom(), this.initModelViewerLibraries(), this.initShopifyXrLaunch(), window.SPR && (SPR.initDomEls(), SPR.loadBadges())
                    },
                    setImageSizes: function() {
                        if (this.settings.hasImages) {
                            var e = this.firstProductImage.currentSrc;
                            e && (this.settings.imageSize = theme.Images.imageSize(e))
                        }
                    },
                    addIdToRecentlyViewed: function() {
                        var e = this.container.getAttribute("data-product-handle"),
                            t = this.container.getAttribute("data-product-url"),
                            a = this.container.getAttribute("data-aspect-ratio"),
                            i = this.container.getAttribute("data-img-url");
                        theme.recentlyViewed.recent.hasOwnProperty(e) && delete theme.recentlyViewed.recent[e], theme.recentlyViewed.recent[e] = {
                            url: t,
                            aspectRatio: a,
                            featuredImage: i
                        }, theme.config.hasLocalStorage && window.localStorage.setItem("theme-recent", JSON.stringify(theme.recentlyViewed.recent))
                    },
                    initVariants: function() {
                        var e = this.container.querySelector(this.selectors.variantsJson);
                        if (e) {
                            this.variantsObject = JSON.parse(e.innerHTML);
                            var t = {
                                    container: this.container,
                                    enableHistoryState: this.settings.enableHistoryState,
                                    singleOptionSelector: this.selectors.singleOptionSelector,
                                    originalSelectorId: this.selectors.originalSelectorId,
                                    variants: this.variantsObject
                                },
                                a = this.container.querySelectorAll(this.selectors.variantColorSwatch);
                            if (a.length && a.forEach(e => {
                                    e.addEventListener("change", function() {
                                        var t = e.dataset.colorName,
                                            a = e.dataset.colorIndex;
                                        this.updateColorName(t, a)
                                    }.bind(this))
                                }), this.variants = new theme.Variants(t), this.storeAvailability) {
                                var o = this.variants.currentVariant ? this.variants.currentVariant.id : this.variants.variants[0].id;
                                this.storeAvailability.updateContent(o), this.container.on("variantChange" + this.settings.namespace, this.updateAvailability.bind(this))
                            }
                            this.container.on("variantChange" + this.settings.namespace, this.updateCartButton.bind(this)), this.container.on("variantImageChange" + this.settings.namespace, this.updateVariantImage.bind(this)), this.container.on("variantPriceChange" + this.settings.namespace, this.updatePrice.bind(this)), this.container.on("variantUnitPriceChange" + this.settings.namespace, this.updateUnitPrice.bind(this)), this.container.querySelector(this.selectors.sku) && this.container.on("variantSKUChange" + this.settings.namespace, this.updateSku.bind(this));
                            var n = this.container.querySelector(this.selectors.inventory);
                            if (n && (this.settings.inventory = !0, this.settings.inventoryThreshold = n.dataset.threshold, this.container.on("variantChange" + this.settings.namespace, this.updateInventory.bind(this))), theme.settings.dynamicVariantsEnable) {
                                var r = this.container.querySelector(this.selectors.currentVariantJson);
                                if (r) {
                                    var s = this.container.querySelector(i.variantType);
                                    s && new theme.VariantAvailability({
                                        container: this.container,
                                        namespace: this.settings.namespace,
                                        type: s.dataset.type,
                                        variantsObject: this.variantsObject,
                                        currentVariantObject: JSON.parse(r.innerHTML)
                                    })
                                }
                            }
                            if (this.settings.imageSetName) {
                                var l = this.container.querySelector(".variant-input-wrap[data-handle=\"" + this.settings.imageSetName + "\"]");
                                l ? (this.settings.imageSetIndex = l.dataset.index, this.container.on("variantChange" + this.settings.namespace, this.updateImageSet.bind(this))) : this.settings.imageSetName = null
                            }
                        }
                    },
                    initQtySelector: function() {
                        this.container.querySelectorAll(".js-qty__wrapper").forEach(e => {
                            new theme.QtySelector(e, {
                                namespace: ".product"
                            })
                        })
                    },
                    initAjaxProductForm: function() {
                        "drawer" === theme.settings.cartType && new theme.AjaxProduct(this.cache.form)
                    },
                    updateColorName: function(e, t) {
                        this.container.querySelector(this.selectors.colorLabel + `[data-index="${t}"`).textContent = e
                    },
                    updateCartButton: function(e) {
                        var t = e.detail.variant,
                            i = this.container.querySelector(this.selectors.addToCart),
                            o = this.container.querySelector(this.selectors.addToCartText);
                        if (!t) i.classList.add(a.disabled), i.disabled = !0, o.textContent = theme.strings.unavailable;
                        else if (t.available) {
                            i.classList.remove(a.disabled), i.disabled = !1;
                            var n = o.dataset.defaultText;
                            o.textContent = n
                        } else i.classList.add(a.disabled), i.disabled = !0, o.textContent = theme.strings.soldOut
                    },
                    updatePrice: function(e) {
                        var t = e.detail.variant;
                        if (t)
                            if (this.cache.price.innerHTML = theme.Currency.formatMoney(t.price, theme.settings.moneyFormat), t.compare_at_price > t.price) {
                                this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(t.compare_at_price, theme.settings.moneyFormat), this.cache.priceWrapper.classList.remove(a.hidden), this.cache.price.classList.add(a.onSale), this.cache.comparePriceA11y.setAttribute("aria-hidden", "false"), this.cache.priceA11y.setAttribute("aria-hidden", "false");
                                var i = t.compare_at_price - t.price;
                                i = "percent" == theme.settings.saveType ? Math.round(100 * i / t.compare_at_price) + "%" : theme.Currency.formatMoney(i, theme.settings.moneyFormat), this.cache.savePrice.classList.remove(a.hidden), this.cache.savePrice.innerHTML = theme.strings.savePrice.replace("[saved_amount]", i)
                            } else this.cache.priceWrapper && this.cache.priceWrapper.classList.add(a.hidden), this.cache.savePrice.classList.add(a.hidden), this.cache.price.classList.remove(a.onSale), this.cache.comparePriceA11y && this.cache.comparePriceA11y.setAttribute("aria-hidden", "true"), this.cache.priceA11y.setAttribute("aria-hidden", "true")
                    },
                    updateUnitPrice: function(e) {
                        var t = e.detail.variant;
                        t && t.unit_price ? (this.container.querySelector(this.selectors.unitPrice).innerHTML = theme.Currency.formatMoney(t.unit_price, theme.settings.moneyFormat), this.container.querySelector(this.selectors.unitPriceBaseUnit).innerHTML = theme.Currency.getBaseUnit(t), this.container.querySelector(this.selectors.unitWrapper).classList.remove(a.hidden)) : this.container.querySelector(this.selectors.unitWrapper).classList.add(a.hidden)
                    },
                    imageSetArguments: function(e) {
                        var e = e ? e : this.variants ? this.variants.currentVariant : null;
                        if (e) {
                            var t = this.settings.currentImageSet = this.getImageSetName(e[this.settings.imageSetIndex]),
                                a = this.settings.imageSetName + "_" + t;
                            return this.settings.currentSlideIndex = 0, {
                                cellSelector: "[data-group=\"" + a + "\"]",
                                imageSet: a,
                                initialIndex: this.settings.currentSlideIndex
                            }
                        }
                    },
                    updateImageSet: function(e) {
                        var t = e ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                        if (t) {
                            var a = this.getImageSetName(t[this.settings.imageSetIndex]);
                            this.settings.currentImageSet === a || this.initProductSlider(t)
                        }
                    },
                    updateImageSetThumbs: function(e) {
                        this.cache.thumbSlider.querySelectorAll(".product__thumb-item").forEach(t => {
                            t.classList.toggle(a.hidden, t.dataset.group !== e)
                        })
                    },
                    getImageSetName: function(e) {
                        return e.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "")
                    },
                    updateSku: function(e) {
                        var t = e.detail.variant,
                            a = "";
                        t && (t.sku && (a = t.sku), this.container.querySelector(this.selectors.sku).textContent = a)
                    },
                    updateInventory: function(e) {
                        var t = e.detail.variant;
                        if (!t || !t.inventory_management || "continue" === t.inventory_policy) return this.toggleInventoryQuantity(t, !1), void this.toggleIncomingInventory(!1);
                        if ("shopify" === t.inventory_management && window.inventories && window.inventories[this.productId]) {
                            var a = window.inventories[this.productId][t.id];
                            if ("continue" === a.policy) return this.toggleInventoryQuantity(t, !1), void this.toggleIncomingInventory(!1);
                            var i = a.quantity,
                                o = !0,
                                n = !1;
                            (0 >= i || i > this.settings.inventoryThreshold) && (o = !1), this.toggleInventoryQuantity(t, o, i), !o && "true" === a.incoming && i <= this.settings.inventoryThreshold && (n = !0), this.toggleIncomingInventory(n, t.available, a.next_incoming_date)
                        }
                    },
                    updateAvailability: function(e) {
                        var t = e.detail.variant;
                        t && this.storeAvailability.updateContent(t.id)
                    },
                    toggleInventoryQuantity: function(e, t, i) {
                        this.settings.inventory || (t = !1);
                        var o = this.container.querySelector(this.selectors.inventory),
                            n = o.closest(".product-block");
                        parseInt(i) <= parseInt(this.settings.inventoryThreshold) ? (o.parentNode.classList.add("inventory--low"), o.textContent = theme.strings.stockLabel.replace("[count]", i)) : (o.parentNode.classList.remove("inventory--low"), o.textContent = theme.strings.inStockLabel), e && e.available ? (o.parentNode.classList.remove(a.hidden), n && n.classList.remove(a.hidden)) : (o.parentNode.classList.add(a.hidden), n && n.classList.add(a.hidden))
                    },
                    toggleIncomingInventory: function(e, t, i) {
                        var o = this.container.querySelector(this.selectors.incomingInventory),
                            n = o.closest(".product-block");
                        if (o) {
                            var r = o.querySelector(".js-incoming-text");
                            if (e) {
                                var s = t ? theme.strings.willNotShipUntil.replace("[date]", i) : theme.strings.willBeInStockAfter.replace("[date]", i);
                                i || (s = theme.strings.waitingForStock), o.classList.remove(a.hidden), n && n.classList.remove(a.hidden), r.textContent = s
                            } else o.classList.add(a.hidden)
                        }
                    },
                    videoSetup: function() {
                        var e = this.cache.mainSlider.querySelectorAll(i.productVideo);
                        return !!e.length && void e.forEach(e => {
                            var t = e.dataset.videoType;
                            "youtube" === t ? this.initYoutubeVideo(e) : "mp4" === t && this.initMp4Video(e)
                        })
                    },
                    initYoutubeVideo: function(e) {
                        t[e.id] = new theme.YouTube(e.id, {
                            videoId: e.dataset.youtubeId,
                            videoParent: i.videoParent,
                            autoplay: !1,
                            style: e.dataset.videoStyle,
                            loop: e.dataset.videoLoop,
                            events: {
                                onReady: this.youtubePlayerReady.bind(this),
                                onStateChange: this.youtubePlayerStateChange.bind(this)
                            }
                        })
                    },
                    youtubePlayerReady: function(e) {
                        var a = e.target.getIframe().id;
                        if (t[a]) {
                            var i = t[a],
                                o = i.videoPlayer;
                            "sound" !== i.options.style && o.mute(), i.parent.classList.remove("loading"), i.parent.classList.add("loaded"), this._isFirstSlide(a) && "sound" !== i.options.style && o.playVideo()
                        }
                    },
                    _isFirstSlide: function(e) {
                        return this.cache.mainSlider.querySelector(i.startingSlide + " #" + e)
                    },
                    youtubePlayerStateChange: function(e) {
                        var a = e.target.getIframe().id,
                            i = t[a];
                        switch (e.data) {
                            case -1:
                                i.attemptedToPlay && i.parent.classList.add("video-interactable");
                                break;
                            case 0:
                                i && "true" === i.options.loop && i.videoPlayer.playVideo();
                                break;
                            case 3:
                                i.attemptedToPlay = !0;
                        }
                    },
                    initMp4Video: function(e) {
                        t[e.id] = {
                            id: e.id,
                            type: "mp4"
                        }, this._isFirstSlide(e.id) && this.playMp4Video(e.id)
                    },
                    stopVideos: function() {
                        for (var [e, a] of Object.entries(t)) a.videoPlayer ? "function" == typeof a.videoPlayer.stopVideo && a.videoPlayer.stopVideo() : "mp4" === a.type && this.stopMp4Video(a.id)
                    },
                    _getVideoType: function(e) {
                        return e.getAttribute("data-video-type")
                    },
                    _getVideoDivId: function(e) {
                        return e.id
                    },
                    playMp4Video: function(e) {
                        var t = this.container.querySelector("#" + e),
                            a = t.play();
                        void 0 !== a && a.then(function() {}).catch(function() {
                            t.setAttribute("controls", ""), t.closest(i.videoParent).setAttribute("data-video-style", "unmuted")
                        })
                    },
                    stopMp4Video: function(e) {
                        var t = this.container.querySelector("#" + e);
                        t && "function" == typeof t.pause && t.pause()
                    },
                    initImageZoom: function() {
                        var e = this.container.querySelector(this.selectors.imageContainer);
                        if (e) {
                            new theme.Photoswipe(e, this.sectionId);
                            e.addEventListener("photoswipe:afterChange", function(e) {
                                this.flickity && this.flickity.goToSlide(e.detail.index)
                            }.bind(this))
                        }
                    },
                    getThumbIndex: function(e) {
                        return e.dataset.index
                    },
                    updateVariantImage: function(e) {
                        var t = e.detail.variant,
                            a = theme.Images.getSizedImageUrl(t.featured_media.preview_image.src, this.settings.imageSize),
                            i = this.container.querySelector(".product__thumb[data-id=\"" + t.featured_media.id + "\"]"),
                            o = this.getThumbIndex(i);
                        "undefined" == typeof o || this.flickity && this.flickity.goToSlide(o)
                    },
                    initProductSlider: function(e) {
                        if (1 >= this.cache.mainSlider.querySelectorAll(i.slide).length) {
                            var t = this.cache.mainSlider.querySelector(i.slide);
                            return void(t && t.classList.add("is-selected"))
                        }
                        if (this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy(), !e) {
                            var a = this.cache.mainSlider.querySelector(i.startingSlide);
                            this.settings.currentSlideIndex = this._slideIndex(a)
                        }
                        var o = {
                            adaptiveHeight: !0,
                            avoidReflow: !0,
                            initialIndex: this.settings.currentSlideIndex,
                            childNav: this.cache.thumbSlider,
                            childNavScroller: this.cache.thumbScroller,
                            childVertical: "beside" === this.cache.thumbSlider.dataset.position,
                            pageDots: !0,
                            wrapAround: !0,
                            callbacks: {
                                onInit: this.onSliderInit.bind(this),
                                onChange: this.onSlideChange.bind(this)
                            }
                        };
                        if (this.settings.imageSetName) {
                            var n = this.imageSetArguments(e);
                            o = Object.assign({}, o, n), this.updateImageSetThumbs(o.imageSet)
                        }
                        this.flickity = new theme.Slideshow(this.cache.mainSlider, o)
                    },
                    onSliderInit: function(e) {
                        this.settings.imageSetName && this.prepMediaOnSlide(e)
                    },
                    onSlideChange: function(e) {
                        if (this.flickity) {
                            var t = this.cache.mainSlider.querySelector(".product-main-slide[data-index=\"" + this.settings.currentSlideIndex + "\"]"),
                                a = this.settings.imageSetName ? this.cache.mainSlider.querySelectorAll(".flickity-slider .product-main-slide")[e] : this.cache.mainSlider.querySelector(".product-main-slide[data-index=\"" + e + "\"]");
                            t.setAttribute("tabindex", "-1"), a.setAttribute("tabindex", 0), this.stopMediaOnSlide(t), this.prepMediaOnSlide(a), this.settings.currentSlideIndex = e
                        }
                    },
                    stopMediaOnSlide(e) {
                        var a = e.querySelector(i.productVideo);
                        if (a) {
                            var o = this._getVideoType(a),
                                n = this._getVideoDivId(a);
                            if ("youtube" === o) {
                                if (t[n].videoPlayer) return void t[n].videoPlayer.stopVideo();
                            } else if ("mp4" === o) return void this.stopMp4Video(n)
                        }
                        var r = e.querySelector(this.selectors.media);
                        r && r.dispatchEvent(new CustomEvent("mediaHidden", {
                            bubbles: !0,
                            cancelable: !0
                        }))
                    },
                    prepMediaOnSlide(e) {
                        var a = e.querySelector(i.productVideo);
                        if (a) {
                            this.flickity.reposition();
                            var o = this._getVideoType(a),
                                n = this._getVideoDivId(a);
                            if ("youtube" !== o) "mp4" === o && this.playMp4Video(n);
                            else if (t[n].videoPlayer && "sound" !== t[n].options.style) return void t[n].videoPlayer.playVideo()
                        }
                        var r = e.querySelector(this.selectors.media);
                        r && (r.dispatchEvent(new CustomEvent("mediaVisible", {
                            bubbles: !0,
                            cancelable: !0
                        })), e.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0), e.querySelector(".product-single__close-media").setAttribute("tabindex", 0))
                    },
                    _slideIndex: function(e) {
                        return e.getAttribute("data-index")
                    },
                    openModalProduct: function() {
                        var e = !1;
                        if (!this.settings.modalInit) {
                            this.blocksHolder = this.container.querySelector(i.blocksHolder);
                            var t = this.blocksHolder.dataset.url;
                            fetch(t).then(function(e) {
                                return e.text()
                            }).then(function(e) {
                                var t = new DOMParser,
                                    a = t.parseFromString(e, "text/html"),
                                    o = a.querySelector(i.blocks);
                                o.querySelectorAll("[id]").forEach(e => {
                                    var t = e.getAttribute("id");
                                    e.setAttribute("id", t + "-modal");
                                    var a = o.querySelector(`[for="${t}"]`);
                                    a && a.setAttribute("for", t + "-modal");
                                    var i = o.querySelector(`[aria-controls="${t}"]`);
                                    i && i.setAttribute("aria-controls", t + "-modal")
                                });
                                var n = o.querySelector(this.selectors.form),
                                    r = n.getAttribute("id");
                                o.querySelectorAll("[form]").forEach(e => {
                                    e.setAttribute("form", r)
                                }), this.blocksHolder.innerHTML = "", this.blocksHolder.append(o), this.blocksHolder.classList.add("product-form-holder--loaded"), this.cacheElements(), this.formSetup(), this.updateModalProductInventory(), Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(), theme.collapsibles.init(this.container), document.dispatchEvent(new CustomEvent("quickview:loaded", {
                                    detail: {
                                        productId: this.sectionId
                                    }
                                }))
                            }.bind(this)), this.productSetup(), this.videoSetup(), this.settings.imageSetName ? this.variants ? this.initProductSlider() : document.addEventListener("quickview:loaded", function(e) {
                                e.detail.productId === this.sectionId && this.initProductSlider()
                            }.bind(this)) : this.initProductSlider(), this.customMediaListners(), this.addIdToRecentlyViewed(), this.settings.modalInit = !0
                        } else e = !0;
                        AOS.refreshHard(), document.dispatchEvent(new CustomEvent("quickview:open", {
                            detail: {
                                initialized: e,
                                productId: this.sectionId
                            }
                        }))
                    },
                    updateModalProductInventory: function() {
                        window.inventories = window.inventories || {}, this.container.querySelectorAll(".js-product-inventory-data").forEach(e => {
                            var t = e.dataset.productId;
                            window.inventories[t] = {}, e.querySelectorAll(".js-variant-inventory-data").forEach(e => {
                                window.inventories[t][e.dataset.id] = {
                                    quantity: e.dataset.quantity,
                                    policy: e.dataset.policy,
                                    incoming: e.dataset.incoming,
                                    next_incoming_date: e.dataset.date
                                }
                            })
                        })
                    },
                    closeModalProduct: function() {
                        this.stopVideos()
                    },
                    initModelViewerLibraries: function() {
                        var e = this.container.querySelectorAll(this.selectors.media);
                        1 > e.length || theme.ProductMedia.init(e, this.sectionId)
                    },
                    initShopifyXrLaunch: function() {
                        document.addEventListener("shopify_xr_launch", function() {
                            var e = this.container.querySelector(this.selectors.productMediaWrapper + ":not(." + self.classes.hidden + ")");
                            e.dispatchEvent(new CustomEvent("xrLaunch", {
                                bubbles: !0,
                                cancelable: !0
                            }))
                        }.bind(this))
                    },
                    customMediaListners: function() {
                        document.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                            e.addEventListener("click", function() {
                                var e = this.cache.mainSlider.querySelector(i.currentSlide),
                                    t = e.querySelector(this.selectors.media);
                                t && t.dispatchEvent(new CustomEvent("mediaHidden", {
                                    bubbles: !0,
                                    cancelable: !0
                                }))
                            }.bind(this))
                        });
                        var e = this.container.querySelectorAll("model-viewer");
                        e.length && e.forEach(e => {
                            e.addEventListener("shopify_model_viewer_ui_toggle_play", function(e) {
                                this.mediaLoaded(e)
                            }.bind(this)), e.addEventListener("shopify_model_viewer_ui_toggle_pause", function(e) {
                                this.mediaUnloaded(e)
                            }.bind(this))
                        })
                    },
                    mediaLoaded: function() {
                        this.container.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                            e.classList.remove(a.hidden)
                        }), this.flickity && this.flickity.setDraggable(!1)
                    },
                    mediaUnloaded: function() {
                        this.container.querySelectorAll(this.selectors.closeMedia).forEach(e => {
                            e.classList.add(a.hidden)
                        }), this.flickity && this.flickity.setDraggable(!0)
                    },
                    onUnload: function() {
                        theme.ProductMedia.removeSectionModels(this.sectionId), this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                    }
                }), e
            }(), theme.RecentlyViewed = function() {
                function e(e) {
                    e && (this.container = e, this.sectionId = this.container.getAttribute("data-section-id"), this.namespace = ".recently-viewed" + this.sectionId, this.gridItemWidth = this.container.getAttribute("data-grid-item-class"), this.rowOf = this.container.getAttribute("data-row-of"), theme.initWhenVisible({
                        element: this.container,
                        callback: this.init.bind(this),
                        threshold: 600
                    }))
                }
                var t = !1;
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        if (!t) {
                            if (t = !0, 0 === Object.keys(theme.recentlyViewed.recent).length && theme.recentlyViewed.recent.constructor === Object) return void this.container.classList.add("hide");
                            this.outputContainer = document.getElementById("RecentlyViewed-" + this.sectionId), this.handle = this.container.getAttribute("data-product-handle");
                            var e = [];
                            Object.keys(theme.recentlyViewed.recent).forEach(function(t) {
                                "undefined" !== t && e.push(this.getProductInfo(t))
                            }.bind(this)), Promise.all(e).then(function(e) {
                                this.setupOutput(e), this.captureProductDetails(e)
                            }.bind(this))
                        }
                    },
                    getProductInfo: function(e) {
                        return new Promise(function(t) {
                            theme.recentlyViewed.productInfo.hasOwnProperty(e) ? t(theme.recentlyViewed.productInfo[e]) : fetch("/products/" + e + ".js").then(function(e) {
                                return e.text()
                            }).then(function(e) {
                                t(e)
                            })
                        })
                    },
                    setupOutput: function(e) {
                        var t = [],
                            a = this.container.getAttribute("data-recent-count"),
                            o = 0;
                        if (Object.keys(e).forEach(function(a) {
                                if (e[a]) {
                                    var i = JSON.parse(e[a]);
                                    if (i.handle !== this.handle && "undefined" != typeof i.handle) {
                                        o++, i.url = theme.recentlyViewed.recent[i.handle] ? theme.recentlyViewed.recent[i.handle].url : i.url, i.image_responsive_url = theme.recentlyViewed.recent[i.handle].featuredImage, i.image_aspect_ratio = theme.recentlyViewed.recent[i.handle].aspectRatio;
                                        var n = i.variants[0];
                                        if (n && n.unit_price) {
                                            var r = "";
                                            n.unit_price_measurement && (1 != n.unit_price_measurement.reference_value && (r += n.unit_price_measurement.reference_value + " "), r += n.unit_price_measurement.reference_unit), i.unit_price = theme.Currency.formatMoney(n.unit_price), "" != r && (i.unit_price += "/" + r)
                                        }
                                        t.unshift(i)
                                    }
                                }
                            }.bind(this)), 0 === t.length) return void this.container.classList.add("hide");
                        var n = theme.buildProductGridItem(t.slice(0, a), this.gridItemWidth, this.rowOf);
                        this.outputContainer.innerHTML = n, AOS && AOS.refreshHard()
                    },
                    captureProductDetails: function(e) {
                        for (var t, a = 0; a < e.length; a++) t = e[a], theme.recentlyViewed.productInfo[t.handle] = t;
                        theme.config.hasSessionStorage && sessionStorage.setItem("recent-products", JSON.stringify(theme.recentlyViewed.productInfo))
                    },
                    onUnload: function() {
                        t = !1
                    }
                }), e
            }(), theme.Testimonials = function() {
                function e(e) {
                    this.container = e, this.timeout;
                    var t = e.getAttribute("data-section-id");
                    this.slideshow = e.querySelector("#Testimonials-" + t), this.namespace = ".testimonial-" + t, this.slideshow && theme.initWhenVisible({
                        element: this.container,
                        callback: this.init.bind(this),
                        threshold: 600
                    })
                }
                var t = {
                    adaptiveHeight: !0,
                    avoidReflow: !0,
                    pageDots: !0,
                    prevNextButtons: !1
                };
                return e.prototype = Object.assign({}, e.prototype, {
                    init: function() {
                        3 >= this.slideshow.dataset.count && (t.wrapAround = !1), this.flickity = new theme.Slideshow(this.slideshow, t), 2 < this.slideshow.dataset.count && (this.timeout = setTimeout(function() {
                            this.flickity.goToSlide(1)
                        }.bind(this), 1e3))
                    },
                    onUnload: function() {
                        this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy()
                    },
                    onDeselect: function() {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                    },
                    onBlockSelect: function(e) {
                        var t = this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId),
                            a = parseInt(t.dataset.index);
                        clearTimeout(this.timeout), this.flickity && "function" == typeof this.flickity.pause && (this.flickity.goToSlide(a), this.flickity.pause())
                    },
                    onBlockDeselect: function() {
                        this.flickity && "function" == typeof this.flickity.play && this.flickity.play()
                    }
                }), e
            }(), theme.isStorageSupported = function(e) {
                if (window.self !== window.top) return !1;
                var t;
                "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
                try {
                    return t.setItem("test", "1"), t.removeItem("test"), !0
                } catch (e) {
                    return !1
                }
            }, theme.reinitProductGridItem = function() {
                AOS && AOS.refreshHard(), theme.initQuickShop(), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), theme.collapsibles.init()
            }, theme.config.hasSessionStorage = theme.isStorageSupported("session"), theme.config.hasLocalStorage = theme.isStorageSupported("local"), AOS.init({
                easing: "ease-out-quad",
                once: !0,
                offset: 60,
                disableMutationObserver: !0
            }), theme.config.hasLocalStorage && (theme.recentlyViewed.localStorage = window.localStorage.getItem("theme-recent"), theme.recentlyViewed.localStorage && (theme.recentlyViewed.recent = JSON.parse(theme.recentlyViewed.localStorage))), theme.recentlyViewed.productInfo = theme.config.hasSessionStorage && sessionStorage["recent-products"] ? JSON.parse(sessionStorage["recent-products"]) : {}, theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches, matchMedia(theme.config.mediaQuerySmall).addListener(function(e) {
                e.matches ? (theme.config.bpSmall = !0, document.dispatchEvent(new CustomEvent("matchSmall"))) : (theme.config.bpSmall = !1, document.dispatchEvent(new CustomEvent("unmatchSmall")))
            }), theme.initGlobals = function() {
                theme.collapsibles.init(), theme.videoModal()
            },
            function(e) {
                "loading" == document.readyState ? document.addEventListener("DOMContentLoaded", e) : e()
            }(function() {
                if (theme.sections = new theme.Sections, theme.sections.register("slideshow-section", theme.SlideshowSection), theme.sections.register("header", theme.HeaderSection), theme.sections.register("product", theme.Product), theme.sections.register("blog", theme.Blog), theme.sections.register("password-header", theme.PasswordHeader), theme.sections.register("photoswipe", theme.Photoswipe), theme.sections.register("product-recommendations", theme.Recommendations), theme.sections.register("background-image", theme.BackgroundImage), theme.sections.register("testimonials", theme.Testimonials), theme.sections.register("video-section", theme.VideoSection), theme.sections.register("map", theme.Maps), theme.sections.register("footer-section", theme.FooterSection), theme.sections.register("store-availability", theme.StoreAvailability), theme.sections.register("recently-viewed", theme.RecentlyViewed), theme.sections.register("newsletter-popup", theme.NewsletterPopup), theme.sections.register("collection-header", theme.CollectionHeader), theme.sections.register("collection-grid", theme.Collection), theme.initGlobals(), theme.initQuickShop(), theme.rteInit(), document.body.classList.contains("template-cart")) {
                    var e = document.getElementById("CartPageForm");
                    e && new theme.CartForm(e)
                }
                theme.settings.predictiveSearch && theme.predictiveSearch.init(), theme.settings.isCustomerTemplate && theme.customerTemplates(), document.dispatchEvent(new CustomEvent("page:loaded"))
            })
    }();




$(document).ready(function() {
    $('.size-container p').each(function() {
        var text = $(this).text();
        var colonIndex = text.indexOf(':');
        if (colonIndex !== -1) {
            var newText = text.slice(colonIndex + 1).trim();
            $(this).text(newText);
        }
    });
});

// Care Section Under Collection Page Air Plants
document.addEventListener("DOMContentLoaded", function() {
    // Get the collection heading text of the current page
    var collectionHeading = document.querySelector('.section-header__title').textContent.trim();

    // Get the section elements by their IDs
    var airPlantsReadMore = document.getElementById('collectioncontent');
    var collectiondefination = document.getElementById('shopify-section-template--16401936679155__2585e83f-3b7b-4e41-b659-094cb0d35620');
    var collectioncaresection = document.getElementById('shopify-section-template--16401936679155__e8f4765c-2326-4957-ae38-7319f6a3d02b');

    // Check if the collection heading is "Air Plants"
    if (collectionHeading === 'Air Plants - Tillandsia') {
        // Show the sections
        if (airPlantsReadMore) {
            airPlantsReadMore.style.display = 'none';
        }
        if (collectiondefination) {
            collectiondefination.style.display = 'block';
        }
        if (collectioncaresection) {
            collectioncaresection.style.display = 'block';
        }
    } else {
        // Hide the sections on other collection pages
        if (airPlantsReadMore) {
            airPlantsReadMore.style.display = 'inline-block';
        }
        if (collectiondefination) {
            collectiondefination.style.display = 'none';
        }
        if (collectioncaresection) {
            collectioncaresection.style.display = 'none';
        }
    }
});

//Read More Scroll Down
document.addEventListener('DOMContentLoaded', function() {
    const readMoreLinks = document.querySelectorAll('.ReadMore');
    readMoreLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetId = link.getAttribute('href');
            scrollToSection(targetId);
        });
    });

    function scrollToSection(targetId) {
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
            const targetHeading = targetElement.querySelector('h2'); // Assuming the heading is an <h2> element
            if (targetHeading) {
                const offset = -130; // Adjust this value to your preference
                const targetPosition = targetHeading.getBoundingClientRect().top + window.pageYOffset + offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }
});

// Custom Greeting Card JS

(function() {
  const container = document.getElementById('gc-main-container');
  const checkbox = document.getElementById('gc_input');
  const select = document.getElementById('gc_variant_select');
  const wrapper = document.querySelector('.gc_variant_wrapper');
  const loader = document.querySelector('.gc-loader');
  
  if (!checkbox || !select || !wrapper) return;

  const greetingProductId = null;

  function setLoading(show) {
    if (container) {
      if (show) {
        container.classList.add('gc-container-loading');
      } else {
        container.classList.remove('gc-container-loading');
      }
    }
    if (loader) {
      loader.style.display = show ? 'inline-flex' : 'none';
    }
    checkbox.disabled = show;
    select.disabled = show;
  }

  async function removeFromCart() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const index = cart.items.findIndex(item => item.product_id == greetingProductId);
      if (index !== -1) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: index + 1, quantity: 0 })
        });
      }
    } catch (err) { console.error(err); }
  }

  async function addToCart(variantId) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const existingItems = cart.items.filter(i => i.product_id == greetingProductId);
    for (let item of existingItems) {
      const lineNumber = cart.items.findIndex(x => x.id === item.id) + 1;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: lineNumber, quantity: 0 })
      });
    }
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
  }

  async function syncFromCart() {
    const cart = await fetch('/cart.js').then(r => r.json());
    const hasCard = cart.items.some(i => i.product_id == greetingProductId);
    checkbox.checked = hasCard;
    if (!hasCard) {
      wrapper.style.display = 'none';
      select.value = '';
    } else {
      wrapper.style.display = 'none';
    }
  }

  checkbox.addEventListener('change', async function() {
    if (this.checked) {
      wrapper.style.display = 'flex';
    } else {
      setLoading(true);
      await removeFromCart();
      wrapper.style.display = 'none';
      select.value = '';
      setLoading(false);
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  });

  select.addEventListener('change', async function() {
    const variantId = this.value;
    if (!variantId) return;
    setLoading(true);
    await addToCart(variantId);
    setLoading(false);
    wrapper.style.display = 'none';
    checkbox.checked = true;
    document.dispatchEvent(new CustomEvent('cart:build'));
  });

  document.addEventListener('cart:updated', syncFromCart);
  document.addEventListener('cart:build', syncFromCart);

  (async () => {
    setLoading(true);
    await syncFromCart();
    setLoading(false);
  })();
})();

// Cart Upsell JS

window.addEventListener('load', () => {
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quick-add-btn');
    if (!btn) return;
    e.preventDefault();
    const variantId = parseInt(btn.dataset.variantId);
    if (!variantId) return;
    btn.disabled = true;
    btn.classList.add('loading');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(() => {
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .finally(() => {
      btn.disabled = false;
      btn.classList.remove('loading');
    });
  });
});


// document.addEventListener('DOMContentLoaded', function () {
//   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

//   if (isSafari) {
//     const btn = document.querySelector('#myButton');
//     if (btn) {
//       btn.addEventListener('click', function (e) {
//         // Run Safari-only logic here
//         console.log('Safari button click executed');
//       });
//     }
//   }
// });